import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import store from "../../index";
import toast from "react-hot-toast";
import { Filter } from "@mui/icons-material";
import { useState } from "react";

const initialState = {
  Data: {},
  Department:[],
  Status: "",
  msg: "",
  loading: false,
  getLoading: false,
  regularizationLoading: false,
  expgetLoading: false,
  error: "",
  Successflag: false,
  stockValue: {},
  stockReqData: {},
  inviceEData: {},
  postLoading: false,
  conversionData: {},
  userGroup: [],
  materialStockData: {},
  exploreData: {},
  trackingData: [],
  customerData: {},
  productanalysisData: {},
  pakingListCarton: [],
  summeryData: [],
  hashtokenData: {},
  CustomisedCaptionGetData: {},
  costingLeatherCost: {
    materialCost: 0,
    leatherOneCost: 0,
    leatherTwoCost: 0,
    leatherThreeCost: 0,
    latestmaterialCost: 0,
    latestleatherOneCost: 0,
    latestleatherTwoCost: 0,
    latestleatherThreeCost: 0,
  },
  customerLeatherData: {},
  summaryData: {},
  deploymentData: {},
  ResignationGetData: {},
  trackingLoading: false,
  materialTrackingData: {
    Rateseries: {},
    Qtyseries: {},
    Amountseries: {},
    categories: [],
    TableData: { data: [] },
  },
  AutogeneratecolumnData: [],
  AutogeneraterowData: [],
  stockorderData: {},
  matrialDcTrackData: [],
  purchaseorderratingData: [],
  searchLoading: false,

  PayrollconfigpayrollAttendanceLoading: false,
  PayrollconfigpayrollAttendanceData: {},
  PayrollconfigpayrollAttendanceStatus: "idle",

  empAttendanceData: {},
  InventrygetData: [],
  InventrygetDataStatus: "idle",
  Inventoryloading: false, //ADDED BY - MANOJ
  payslipAttendanceData: {},
  empAttendanceDataLoading: false, //ADDED BY - MANOJ
  AttendanceData: {},
  AttendanceDataLoading: false,
  RegGetData: {},
  leaveweeklyData: {
    Employee: "",
    Year: "",
    LeaveDetailsData: {
      TableData: [],
      Others: [],
    },
  },
  timeSheetData: {},
  MonthlyAttendanceData: [],
  MonthlyAttendanceDataGetloading: false,
  sprintget: {},
  sprintPPget: [],
  sprintgetstatus: "",
  sprintloading: false,
  partyBankgetdata: {},
  partyBankgetstatus: "",
  partyBankgetloading: false,
  OHPaymentPutdata: {},
  OHPaymentPutstatus: "",
  OHPaymentPutloading: false,
  PartyDateAndAmtFilterdata: [],
  PartyDateAndAmtFilterstatus: "",
  PartyDateAndAmtFilterloading: false,
  LeaveEntryRegdata: [],
  //Inventorygrid1
  Inventorygrid1status: "",
  Inventorygrid1loading: false,
  Inventorygrid1data: [],
  //Inventorygrid2
  Inventorygrid2status: "",
  Inventorygrid2loading: false,
  Inventorygrid2data: [],
  //Inventorygrid3
  Inventorygrid3status: "",
  Inventorygrid3loading: false,
  Inventorygrid3data: [],

  Partygetdata: [],
  Partycontactgetdata: [],
  LeaveEntryRegstatus: "",
  Partygetstatus: "",
  Partygetloading: false,
  LeaveEntryRegloading: false,
  Partycontactgetstatus: "",
  Partycontactgetloading: false,
  partyBankPostdata: {},
  partyContactgetdata: {},
  skillInsights1getdata: {},
  skillInsights1status: "",
  skillInsights1loading: false,
  skillInsights2getdata: [],
  skillInsights2status: "",
  skillInsights2loading: false,
  schedulegetdata: [],
  schedulestatus: "",
  scheduleloading: false,
  appraisalSchedulegetdata: [],
  appraisalSchedulegetdatastatus: "",
  appraisalSchedulegetdataloading: false,
  vendorregisterGetData: {},
  vendorregisterGetDatastatus: "",
  vendorregisterGetDataloading: false,
  itemFlagGetDataGetData: {},
  itemFlagGetDatastatus: "",
  itemFlagGetDataloading: false,
  itemStockGetData: {},
  itemStockGetDatastatus: "",
  itemStockGetDataloading: false,
  itemMainGETFetchData: {},
  itemMainGETFetchDatastatus: "",
  itemMainGETFetchDataloading: false,

  vendorDefaultGetData: {},
  vendorDefaultGetDatastatus: "",
  vendorDefaultGetDataloading: false,
  itemMainGetData: {},
  itemMainGetDatastatus: "",
  itemMainGetDataloading: false,
  leaderEnquiryGetData: {},
  leaderEnquiryGetDatastatus: "",
  leaderEnquiryGetDataloading: false,
  DefaultProductDeliveryChargeGetData: {},
  DefaultProductDeliveryChargeGetDatastatus: "",
  DefaultProductDeliveryChargeGetDataloading: false,
  projectCostinggetdata: {},
  projectCostingstatus: "",
  projectCostingloading: false,
  OrderdetailReportgetdata: {},
  OrderdetailReportgetstatus: "",
  OrderdetailReportloading: false,
  leaderDetails: null,
  data: null, // Store your fetched data here
  status: "idle",
  error: null,

  Auditgetdata: [],
  Auditgetstatus: "idle",
  Auditgetloading: false,

  //Audit CompanyGet
  AuditScreennamegetdata: [],
  Auditcompanygetstatus: "idle",
  Auditcompanygetloading: false,

  //PAYSLIP
  paySlipdata: [],
  paySlipstatus: "",
  paySliploading: false,
//CRM_ITEM_STOCK_ANALYTICS
Itemstockstatus: "",
 itemstockDataAnalyticsLoading: false,
  itemstockDataAnalytics:[],

  //ORDER ITEM --> REPLACEMENT QTY
  replacementQtyGetdata: {},
  replacementQtyGetstatus: "",
  replacementQtyGetloading: false,

  //SOP PROCESS
  SOPProcessdata: {},
  SOPProcessLoading: false,
  SOPProcessStatus: "",


  //SOP CONFIG POST
  SOPConfigdata: {},
  SOPConfigLoading: false,
  SOPConfigStatus: "",

  //SOP CONFIG GET
  SOPConfigGetdata: {},
  SOPConfigGetloading: false,
  SOPConfigGetStatus: "",

  //SPECIMEN GET
  SpecimenGetdata: {},
  SpecimenGetloading: false,
  SpecimenGetStatus: "",

  //SPECIMEN POST
  SpecimenPostdata: {},
  SpecimenPostloading: false,
  SpecimenPostStatus: "",

  //SopEmpMappingController - POST
  SopEmpMappingControllerdata: {},
  SopEmpMappingControllerloading: false,
  SopEmpMappingControllerStatus: "",

  //SCOREBOARD
  // ScoredashBoardGetData: {},
  // ScoredashBoardGetStaus: "idle",
  // ScoredashBoardGetLoading: false,
  // ScoredashBoardGetError: null,

  //PARTY ORDER PENDING GET
  PartyOrderPendingGetdata: {},
  PartyOrderPendingGetloading: false,
  PartyOrderPendingGetStatus: "",


  //SOP TIMELINE GET
  SOPTimelinedata: {},
  SOPTimelineloading: false,
  SOPTimelinestatus: "",

  //GetOverflowAffectedOrders GET
  GetOverflowAffectedOrdersdata: {},
  GetOverflowAffectedOrdersloading: false,
  GetOverflowAffectedOrdersstatus: "",


  //PartyReset POST
  PartyResetdata: {},
  PartyResetloading: false,
  PartyResetstatus: "",

  Timetableresetstatus: "",
  Timetableresetloading: false,
  Timetableresetdata: {},

  PublishEventstatus: "",
  PublishEventloading: false,
  PublishEventdata: {},


  //PartyAnalytics POST
  PartyAnalyticsdata: {},
  PartyAnalyticsloading: false,
  PartyAnalyticsstatus: "",

  //CONTRACT INVOICE GET
  InvoiceHeaderData: [],
  InvoiceDetailData: [],
  InvoiceBaseUrl: "",
  PolicygetLoading: false,
  PolicyStatus: "",
  PolicyData: {},
  companytermsgetLoading: false,
  companytermsStatus: "",
  companytermsData: [],
  slotLoading: false,
  slotStatus: "",
  slotgetData: [],

};

export const subscriptionRenewal = createAsyncThunk(
  "SUB/subscriptionRenewal",
  async ({ data }, thunkAPI) => {
    try {
      var url = store.getState().globalurl.subsNewUrl;
      console.log("get" + JSON.stringify(data));
      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("🚀 ~ response.data:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const subScriptionCheck = createAsyncThunk(
  "sub/subScriptionCheck",
  async ({ data }) => {
    var url = store.getState().globalurl.subCheckUrl;
    // var url = store.getState().globalurl.employeeattendanceUrl;

    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
// export const empAttendance = createAsyncThunk(
//   "employee/Payrollattendance",
//   async ({ data }) => {

//     var url = store.getState().globalurl.payrollattendanceUrl;
//     // var url = store.getState().globalurl.employeeattendanceUrl;

//     console.log("get" + JSON.stringify(data));
//     console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
//     const response = await axios.post(url, data, {
//       headers: {
//         Authorization:
//           "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
//       },
//     });
//     console.log(
//       "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
//       response
//     );
//     return response.data;
//   }
// );
export const CustomerpriceorderQty = createAsyncThunk(
  "products/Customerprice",
  async ({ data }) => {
    var url = store.getState().globalurl.CustomerPriceorderQtyUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const Attendance = createAsyncThunk(
  "employee/attendance",
  async ({ data }) => {
    var url = store.getState().globalurl.attendanceUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
/*attendance-- Process button*/
export const AttendanceProcess = createAsyncThunk(
  "employee/attendanceprocess",
  async ({ data }) => {
    console.log("get" + JSON.stringify(data));
    var url = store.getState().globalurl.attendanceprocessUrl;

    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

export const costingBOMData = createAsyncThunk(
  "BOM/costing",
  async ({ HeaderRecordID, ProductRecordID }) => {
    var url = store.getState().globalurl.costingMatrialUrl;
    var data = {
      HeaderRecordID: HeaderRecordID,
      ProductRecordID: ProductRecordID,
    };
    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const materialDcTrckData = createAsyncThunk(
  "matrial/dc-tracking",
  async ({ MaterialID, Type }) => {
    var url = store.getState().globalurl.trackingUrl;
    var data = {
      MaterialID,
      Type,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

//Employee -- GEO LOCATION get
export const geolocationData = createAsyncThunk(
  "Employee/Geo Location",
  async ({ empID }) => {
    var url = store.getState().globalurl.geolocationgetUrl;
    var data = {
      Query: {
        empID: empID,
      },
    };

    data = JSON.stringify(data);
    console.log("get" + data);

    const response = await axios.get(url, {
      params: {
        data: data,
      },
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });

    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

//Employee --GEO Location Update
export const geolocUpdate = createAsyncThunk(
  "Employee/geollocation update",
  async (data) => {
    var url = store.getState().globalurl.geolocationupdateUrl;

    console.log("get" + JSON.stringify(data));
    // console.log(data.idata, "--idata");

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

export const searchData = createAsyncThunk("all/search", async ({ data }) => {
  var url = store.getState().globalurl.searchUrl;

  console.log("get" + JSON.stringify(data));
  const response = await axios.post(url, data, {
    headers: {
      Authorization:
        "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
    },
  });
  console.log(
    "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
    response,
  );
  return response.data;
});
export const LeaderData = createAsyncThunk("all/search", async ({ data }) => {
  var url = store.getState().globalurl.Leadergeturl;

  console.log("get" + JSON.stringify(data));
  const response = await axios.post(url, data, {
    headers: {
      Authorization:
        "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
    },
  });
  console.log(
    "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
    response,
  );
  return response.data;
});
export const materialDcTrckChartData = createAsyncThunk(
  "matrial/dc-tracking-chart",
  async ({ RecordID, Type }) => {
    var url = store.getState().globalurl.materialsTrackingUrl;
    var data = {
      Query: {
        RecordID: RecordID,
        Type: Type,
      },
    };
    data = JSON.stringify(data);
    console.log("get" + JSON.stringify(data));
    const response = await axios.get(url, {
      params: {
        data: data,
      },
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
//Material Stock Order
export const stockorder = createAsyncThunk(
  "material category/material stock order",
  async ({ data }) => {
    // var url = 'http://localhost:8080/MYPROJECT/lgems-api/materialStockOrderTrack.php'
    var url = store.getState().globalurl.stockorderUrl;

    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
//purchaseorderratingData//
export const purchaseorderrating = createAsyncThunk(
  "purchase indent order/ rating",
  async ({ data }) => {
    var url = store.getState().globalurl.PurchaseorderratingUrl;

    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);




// CRM/ITEM_STOCK_GET
export const ItemstockAnalyticsGET = createAsyncThunk(
  "CRM/ITEM_STOCK_GET",
  async ({ CompanyID, EmployeeID, FromDate, ToDate }) => {
    var url = store.getState().globalurl.ItemAlyticsUrl;
    var data = {
      // Query: {
      CompanyID: CompanyID,
      EmployeeID: EmployeeID,
      FromDate: FromDate,
      ToDate: ToDate

      // },
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.get(url, {
      params: {
        data: JSON.stringify(data),
      },
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
// Material Procurement

export const procurementTrackingGet = createAsyncThunk(
  "materil/procurement",
  async ({ RecordID, Type }) => {
    var url = store.getState().globalurl.matProcurementUrl;
    var data = {
      Query: {
        RecordID: RecordID,
        Type,
      },
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.get(url, {
      params: {
        data: JSON.stringify(data),
      },
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
//Customer Leather
export const customerLeather = createAsyncThunk(
  "customer/leather",
  async ({ HeaderRecordID, ProductRecordID, CustomerRecordID }) => {
    var url = store.getState().globalurl.customerLeatherUrl;
    var data = {
      HeaderRecordID: HeaderRecordID,
      ProductRecordID: ProductRecordID,
      CustomerRecordID: CustomerRecordID,
    };
    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

//DC Summary
export const dcSummary = createAsyncThunk(
  "delivery challan/summary",
  async ({ HeaderID, Type }) => {
    var url = store.getState().globalurl.dcsummaryUrl;
    var data = {
      HeaderID: HeaderID,
      Type,
    };
    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const dcpostSummary = createAsyncThunk(
  "delivery challan/summary/postdata",
  async ({ data }) => {
    var url = store.getState().globalurl.dcpostsummaryUrl;
    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
//Employee Deployment
export const getDeployment = createAsyncThunk(
  "employee/deployment",
  async ({ HeaderID }) => {
    var url = store.getState().globalurl.getempdeploymentUrl;
    var data = {
      HeaderID: HeaderID,
    };
    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const postDeployment = createAsyncThunk(
  "employee/deployment/postdata",
  async ({ data }) => {
    var url = store.getState().globalurl.postempdeployment;
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

//Employee_RESIGNATION_GET
export const getResignation = createAsyncThunk(
  "Personnel/Resignation",
  async ({ EmployeeID }) => {
    var url = store.getState().globalurl.getResignationUrl;
    var data = {
      EmployeeID: EmployeeID,
    };
    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

export const ResignationPOST = createAsyncThunk(
  "Personnel/Explore/postResignation",
  async ({ data }) => {
    var url = store.getState().globalurl.postResignation;
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const partypost = createAsyncThunk(
  "employee/deployment/postdata",
  async (payload) => {
    const url = store.getState().globalurl.Parentposturl;

    console.log(" Final API Payload:", payload);

    const response = await axios.post(url, payload, {
      headers: {
        Authorization: "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });

    return response.data;
  }
);
export const Processpost = createAsyncThunk(
  "employee/deployment/postdata",
  async (payload) => {
    const url = store.getState().globalurl.Processposturl;

    console.log("Final API Payload:", payload);

    const response = await axios.post(url, payload, {
      headers: {
        Authorization: "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });

    return response.data;
  }
);
export const InventoryPostController = createAsyncThunk(
  "employee/deployment/postdata",
  async (payload) => {
    const url = store.getState().globalurl.EmpInventoryPostController;

    console.log("Final API Payload:", payload);

    const response = await axios.post(url, payload, {
      headers: {
        Authorization: "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });

    return response.data;
  }
);

export const costLeatherData = createAsyncThunk(
  "bom/costing/leather",
  async ({ HeaderRecordID, LeatherRecordID, LeatherNumber }) => {
    var url = store.getState().globalurl.costingLeatherUrl;
    var data = {
      HeaderRecordID: HeaderRecordID,
      LeatherRecordID: LeatherRecordID,
      LeatherNumber,
    };
    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });

    return response.data;
  },
);

export const conversionMaterialData = createAsyncThunk(
  "Conversion",
  async ({ ConversionID }) => {
    var url = store.getState().globalurl.conversionUrl;
    var data = { ConversionID: ConversionID };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

export const uomMaterialRate = createAsyncThunk(
  "material/conversion",
  async ({ fromUomID, toUomID, Type }) => {
    var url = store.getState().globalurl.materialUomCovUrl;
    var data = { FromUOMID: fromUomID, ToUOMID: toUomID, Type };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const dpConversionData = createAsyncThunk(
  "Product/conversion",
  async ({ Purchase, FromID, Type, MaterialID }) => {
    //alert("purchase"+Purchase);
    var url = store.getState().globalurl.designPUrl;
    var data = {
      ConversionID: Purchase,
      FromID: FromID,
      Type: Type,
      MaterialID: MaterialID,
    };
    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:98 ~ data:", data);
    //alert("data---"+data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const StockProcessApi = createAsyncThunk(
  "Stock/process",
  async (props) => {
    var url = store.getState().globalurl.imageNameUpdateUrl;
    var data = {
      accessid: props.accessID,
      Recordid: props.recID,
      ImageName: "",
      Action: "",
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    // console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  },
);

export const cbmCalculation = createAsyncThunk(
  "packinglist/cbmcalculation",
  async ({ data }) => {
    var url = store.getState().globalurl.packinglistCbmUrl;
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    // console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  },
);

export const bomCopyFn = createAsyncThunk(
  "Stock/process",
  async ({ data, accessID }) => {
    var url =
      accessID == "TR001"
        ? store.getState().globalurl.bomCopyUrl
        : store.getState().globalurl.bomCopyJobworkUrl;
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    // console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  },
);
export const invoiceHeaderGetData = createAsyncThunk(
  "Invoice/Header",
  async (props) => {
    var url = store.getState().globalurl.apiUrl;
    const data = {
      accessid: props.accessID,
      action: props.get,
      recid: props.recID,
    };
    console.log("🚀 ~ data:", JSON.stringify(data));

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

export const invoiceExploreGetData = createAsyncThunk(
  "Invoice/explore",
  async ({ accessID, get, recID }) => {
    var url = store.getState().globalurl.apiUrl;
    const data = {
      accessid: accessID,
      action: get,
      recid: recID,
    };

    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const RegGetData = createAsyncThunk(
  "RegGetData/getdata",
  async ({ data }, thunkAPI) => {
    try {
      var url = store.getState().globalurl.regGetUrl;
      console.log("get" + JSON.stringify(data));
      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("🚀 ~ response.data:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const getLeaveentryData = createAsyncThunk(
  "Leave Entry/get",
  async ({ EmployeeID, LeaveTypeID }) => {
    const url = store.getState().globalurl.getLeaveentryDataUrl;
    console.log(url, "--find url");

    const data = {
      EmployeeID: EmployeeID,
      LeaveTypeID: LeaveTypeID,
    };
    console.log("get" + JSON.stringify(data));
    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const getLeaveweeklyData = createAsyncThunk(
  "Leave Weekly/get",
  async ({ EmployeeID }) => {
    const url = store.getState().globalurl.getLeaveweeklyDataUrl;
    console.log(url, "--find url");

    const data = {
      EmployeeID: EmployeeID,
    };
    console.log("get" + JSON.stringify(data));
    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const stockGetData = createAsyncThunk(
  "stock/material",
  async ({ accessID, Type, recID, yearData }) => {
    var url = store.getState().globalurl.stockUrl;
    var data = {
      Query: {
        accessid: accessID,
        recid: recID,
        Type: Type,
        Year: yearData,
      },
    };
    data = JSON.stringify(data);

    console.log("get" + data);
    const response = await axios.get(url, {
      params: {
        data: data,
      },

      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data.Data;
  },
);
export const requestMail = createAsyncThunk(
  "email/rquestmail",
  async (data) => {
    var url = store.getState().globalurl.requestAcknowledgeUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const leaveAppoval = createAsyncThunk(
  "leave/approval",
  async ({ data }, thunkAPI) => {
    try {
      var url = store.getState().globalurl.leavelApprovalUrl;
      console.log("get" + JSON.stringify(data));
      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("🚀 ~ response.data:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const InvoicePostData = createAsyncThunk(
  "PostData/header/details",
  async ({ accessID, action, idata }) => {
    const url = store.getState().globalurl.apiUrl;
    const data = {
      accessid: accessID,
      action: action,
      data: idata,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

export const InvoicePostExploreData = createAsyncThunk(
  "PostData/explore/details",
  async ({ accessID, action, idata }) => {
    const url = store.getState().globalurl.apiUrl;
    const data = {
      accessid: accessID,
      action: action,
      data: idata,
    };
    console.log(
      "🚀 ~ file: Formapireducer.js:209 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

export const getFetchData = createAsyncThunk(
  "allScreen/Header",
  async ({ accessID, get, recID }) => {
    var url = store.getState().globalurl.apiUrl;

    const data = {
      accessid: accessID,
      action: get,
      recid: recID,
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );

    return response.data;
  },
);
export const getFetchFeeData = createAsyncThunk(
  "Feestructure/Header",
  async ({ accessID, get, recID, AcademicType }) => {
    var url = store.getState().globalurl.apiUrl;

    const data = {
      accessid: accessID,
      action: get,
      recid: recID,
      AcademicType: AcademicType,
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );

    return response.data;
  },
);
export const getFetchCashData = createAsyncThunk(
  "CashManagement/Header",
  async ({ accessID, get, recID, CompanyID }) => {
    var url = store.getState().globalurl.apiUrl;

    const data = {
      accessid: accessID,
      action: get,
      recid: recID,
      CompanyID: CompanyID,
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );

    return response.data;
  },
);
export const getFetchData_v1 = createAsyncThunk(
  "allScreen_v1/Header_v1",
  async ({ accessID, get, recID, CompanyID }) => {
    var url = store.getState().globalurl.apiUrl;

    const data = {
      accessid: accessID,
      action: get,
      recid: recID,
      CompanyID: CompanyID
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );

    return response.data;
  },
);
export const EventsgetData = createAsyncThunk(
  "EventsgetData/get",
  async ({ accessID, get, recID, Type }) => {
    var url = store.getState().globalurl.apiUrl;

    const data = {
      accessid: accessID,
      action: get,
      recid: recID,
      Type:Type
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );

    return response.data;
  },
);
export const ModuleUrl = createAsyncThunk(
  "ModuleFetchData/Header",
  async ({ CompanyID }) => {
    var url = store.getState().globalurl.Moduleurl;
    const data = {
      CompanyID: CompanyID,
    };

    console.log("🚀 ~ Sending request with data:", JSON.stringify(data));

    try {
      // Send POST request with axios
      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("🚀 ~ Response received:", response);
      return response.data;
    } catch (error) {
      console.error("Error during API call:", error);
      throw error;
    }
  },
);
export const VendorRegisterFetchData = createAsyncThunk(
  "VendorRegisterFetchData/Header",
  async ({ get, recID }) => {
    var url = store.getState().globalurl.VendorRegistrationGet;
    const data = {
      action: get,
      recid: recID,
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

export const ItemFlagFetchData = createAsyncThunk(
  "ItemFlagFetchData/Header",
  async ({ get, recID }) => {
    var url = store.getState().globalurl.ItemFlagMenuGet;
    const data = {
      action: get,
      recid: recID,
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const ItemStockMenuGet = createAsyncThunk(
  "ItemStockMenuGet/Header",
  async ({ get, recID }) => {
    var url = store.getState().globalurl.ItemStockMenuGet;
    const data = {
      action: get,
      recid: recID,
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

export const ItemMainGETFetchData = createAsyncThunk(
  "ItemMainGETFetchData/Header",
  async ({ get, recID }) => {
    var url = store.getState().globalurl.ItemMainGETFetchData;
    const data = {
      action: get,
      recid: recID,
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const VendorDefaultFetchData = createAsyncThunk(
  "VendorDefaultFetchData/Header",
  async ({ get, recID }) => {
    var url = store.getState().globalurl.VendorDefaultGET;
    const data = {
      action: get,
      recid: recID,
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const ItemMainMenuFetchData = createAsyncThunk(
  "ItemMainMenuFetchData/Header",
  async ({ get, CompanyID, ItemCategoryID }) => {
    var url = store.getState().globalurl.ItemMainMenu;
    const data = {
      action: get,
      data: {
        CompanyID: CompanyID,
        ItemCategoryID: ItemCategoryID,
      },
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const LeadEnquiryFilterGet = createAsyncThunk(
  "LeadEnquiryFilterGet/Header",
  async ({ recID }) => {
    var url = store.getState().globalurl.LeadEnquiryFilterGet;
    const data = {
      LeaderID: recID,
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

export const DefaultProductDeliveryChargeGet = createAsyncThunk(
  "DefaultProductDeliveryChargeGet/Header",
  async ({ PartyRecordID }) => {
    var url = store.getState().globalurl.DefaultProductDeliveryChargeGet;
    const data = {
      PartyID: PartyRecordID,
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
//PartyBank Get
export const PartyBankget = createAsyncThunk(
  "party bank/Get",
  async ({ VendorID }) => {
    var url = store.getState().globalurl.partyBankUrl;
    const data = {
      VendorID: VendorID,
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
//partyBank Post
export const partyBankpostData = createAsyncThunk(
  "partyBankpostData/partyBankpostData",
  async ({ action, idata }) => {
    const url = store.getState().globalurl.partyBankPostUrl;

    const data = {
      action: action,
      ...idata,
      // data: idata,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

//partyContact Get
export const PartyContactget = createAsyncThunk(
  "PartyContactget/Get",
  async ({ VendorID }) => {
    var url = store.getState().globalurl.partyContactgetUrl;
    const data = {
      VendorID: VendorID,
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
//partyContact Post
export const partyContactData = createAsyncThunk(
  "partyContactData/partycontact",
  async ({ action, idata }) => {
    const url = store.getState().globalurl.partyContactPostUrl;

    const data = {
      action: action,
      ...idata,
      // data: idata,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

//Sprint Get
export const sprintGetData = createAsyncThunk(
  "Project/Sprint",
  async ({ SprintHeaderID }) => {
    var url = store.getState().globalurl.SprintgetUrl;
    const data = {
      SprintHeaderID: SprintHeaderID,
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

//Sprint Project Plan Get
export const sprintprojectplanGetData = createAsyncThunk(
  "Project Plan get/Sprint",
  async ({ ActivitiesID, FromDate, ToDate }) => {
    var url = store.getState().globalurl.SprintPPGetUrl;
    const data = {
      ActivitiesID: ActivitiesID,
      FromDate: FromDate,
      ToDate: ToDate,
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

//NEW SCHEDULE
export const scheduleGetData = createAsyncThunk(
  "scheduleGetData/get",
  async ({ AssessmentID }) => {
    var url = store.getState().globalurl.ScheduleGetController;
    const data = {
      AssessmentID: AssessmentID,
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

//APPRAISAL BASED SCHEDULE
export const appraisalscheduleGetData = createAsyncThunk(
  "appraisalscheduleGetData/get",
  async ({ DesignationID, AssessmentType }) => {
    var url = store.getState().globalurl.AppraisalScheduleGetcontroller;
    const data = {
      DesignationID: DesignationID,
      AssessmentType: AssessmentType,
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
//SKILL-INSIGHTS
export const getInsights1 = createAsyncThunk("getInsights1/get", async () => {
  const url = store.getState().globalurl.InsightsUrl1;

  const response = await axios.post(
    url,
    {}, //  empty body since API doesn't need input
    {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    },
  );

  console.log("API Response:", response.data);
  return response.data;
});

export const getInsights2 = createAsyncThunk(
  "getInsights2/get",
  async (AssessmentID) => {
    const url = store.getState().globalurl.InsightsUrl2;

    const response = await axios.post(
      url,
      { AssessmentID: AssessmentID },
      {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      },
    );

    console.log("API Response:", response.data);
    return response.data;
  },
);

//PROJECT COSTING
export const getProjectCosting = createAsyncThunk(
  "getProjectCosting/get",
  async ({ ProjectID, EmployeeID }) => {
    const url = store.getState().globalurl.ProjectCostingPDF;

    const response = await axios.post(
      url,
      {
        ProjectID,
        EmployeeID,
      },
      {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      },
    );

    console.log("API Response:", response.data);
    return response.data;
  },
);

//ORDER HEADER PDF
export const getOrderdetailReport = createAsyncThunk(
  "getOrderdetailReport/get",
  async ({ PartyID, OrderHdrID, CompanyID }) => {
    const url = store.getState().globalurl.OrderdetailReport;

    const response = await axios.post(
      url,
      {
        PartyID,
        OrderHdrID,
        CompanyID,
      },
      {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      },
    );

    console.log("API Response:", response.data);
    return response.data;
  },
);
/* settings Get*/
export const getSettingsData = createAsyncThunk(
  "Settings/get",
  async ({ SubscriptionCode }) => {
    // Destructure the SubscriptionCode here
    const url = store.getState().globalurl.settingsgetUrl;
    console.log(url, "--find url");

    const data = {
      SubscriptionCode: SubscriptionCode, // Now using SubscriptionCode passed via the thunk
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const getBiometricData = createAsyncThunk(
  "Biometric/get",
  async ({ CompanyID }) => {
    // Destructure the CompanyID here
    const url = store.getState().globalurl.biometricgetUrl;
    console.log(url, "--find url");

    const data = {
      CompanyID, // Now using SubscriptionCode passed via the thunk
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

// Settings -- Approvals Checkbox
export const setttingsApprovalsData = createAsyncThunk(
  "setttingsApprovalsData/Approvals get",
  async ({ CompanyID }) => {
    // Destructure the CompanyID here
    const url = store.getState().globalurl.settingsapprovalGetUrl;
    console.log(url, "--find url");

    const data = {
      CompanyID, // Now using SubscriptionCode passed via the thunk
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

export const getJioData = createAsyncThunk(
  "Biometric/getyyyyyy",
  async ({ CompanyID }) => {
    // Destructure the CompanyID here
    const url = store.getState().globalurl.jiogetUrl;
    console.log(url, "--find url");

    const data = {
      CompanyID, // Now using SubscriptionCode passed via the thunk
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const CustomisedCaptionGet = createAsyncThunk(
  "CustomisedCaptionGet/CaptionGet",
  async ({ Vertical, AccessID }, { getState }) => {
    try {
      const url = getState().globalurl.CustomisedCaptionGet;

      const data = {
        Vertical,
        AccessID,
      };

      console.log("🚀 API Payload:", data);

      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "your_token_here",
        },
      });

      console.log("API Response:", response.data);

      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  }
);
export const Regularizationdata = createAsyncThunk(
  "regularization",
  async ({ accessID, get, recID }) => {
    var url = store.getState().globalurl.regularizationUrl;
    const data = {
      accessid: accessID,
      action: get,
      recid: recID,
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

export const postData = createAsyncThunk(
  "allScreen/post",
  async ({ accessID, action, idata }) => {
    const url = store.getState().globalurl.apiUrl;

    const data = {
      accessid: accessID,
      action: action,
      data: idata,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const EventspostData = createAsyncThunk(
  "EventspostData/post",
  async ({ accessID, action, idata, Type,CompanyID }) => {
    const url = store.getState().globalurl.apiUrl;

    const data = {
      accessid: accessID,
      action: action,
      data: idata,
      Type:Type,
      CompanyID:CompanyID
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const ItemMainpostData = createAsyncThunk(
  "ItemMainpostData/post",
  async ({ action, idata }) => {
    const url = store.getState().globalurl.ItemMainMenu;

    const data = {
      action: action,
      data: idata,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const ItemFlagMenuPut = createAsyncThunk(
  "ItemFlagMenuPut/post",
  async ({ action, idata }) => {
    const url = store.getState().globalurl.ItemFlagMenuPut;

    const data = {
      action: action,
      data: idata,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const ItemStockMenuPut = createAsyncThunk(
  "ItemStockMenuPut/post",
  async ({ action, idata }) => {
    const url = store.getState().globalurl.ItemStockMenuPut;

    const data = {
      action: action,
      data: idata,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const VendorRegisterpostData = createAsyncThunk(
  "VendorRegisterpostData/post",
  async ({ accessID, action, idata }) => {
    const url = store.getState().globalurl.VendorRegistration;

    const data = {
      accessid: accessID,
      action: action,
      data: idata,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const VendorDefaultPUTdata = createAsyncThunk(
  "VendorDefaultPUTdata/post",
  async ({ accessID, action, idata }) => {
    const url = store.getState().globalurl.VendorDefaultPUT;

    const data = {
      accessid: accessID,
      action: action,
      data: idata,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const ItemFlagPostdata = createAsyncThunk(
  "ItemFlagPostdata/post",
  async ({ action, idata }) => {
    const url = store.getState().globalurl.VendorDefaultPUT;

    const data = {
      action: action,
      data: idata,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
//Settings Post

export const SettingspostData = createAsyncThunk(
  "Settings/SubSettings Post",
  async ({ idata }) => {
    const url = store.getState().globalurl.settingsPostUrl;

    // const data = {
    //   UserName: UserName,
    //   OldPassword: OldPassword,
    //   NewPassword: NewPassword,
    // };
    console.log("get" + JSON.stringify(idata));
    const response = await axios.post(url, idata, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const CompanydetailpostData = createAsyncThunk(
  "Company/Sub Post",
  async ({ idata }) => {
    const url = store.getState().globalurl.compdetailPostUrl;

    // const data = {
    //   UserName: UserName,
    //   OldPassword: OldPassword,
    //   NewPassword: NewPassword,
    // };
    console.log("get" + JSON.stringify(idata));
    const response = await axios.post(url, idata, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const BiometricpostData = createAsyncThunk(
  "biometric/Sub Post",
  async ({ idata }) => {
    const url = store.getState().globalurl.biometricPostUrl;

    // const data = {
    //   UserName: UserName,
    //   OldPassword: OldPassword,
    //   NewPassword: NewPassword,
    // };
    console.log("get" + JSON.stringify(idata));
    const response = await axios.post(url, idata, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

//settings Approvals
export const ApprovalsettingspostData = createAsyncThunk(
  "ApprovalsettingspostData/Approvals Post",
  async ({ idata }) => {
    const url = store.getState().globalurl.settingsapprovalPOSTtUrl;

    // const data = {
    //   UserName: UserName,
    //   OldPassword: OldPassword,
    //   NewPassword: NewPassword,
    // };
    console.log("get" + JSON.stringify(idata));
    const response = await axios.post(url, idata, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

export const getFetchWeightage = createAsyncThunk(
  "allScreen/Header",
  async ({ Type, HeaderID, CompanyID }) => {
    const url = store.getState().globalurl.apiweightageUrl;

    const data = {
      Type: Type, // Ensure lowercase if required by API
      HeaderID: HeaderID,
      CompanyID,
    };

    console.log("🚀 Request Data:", JSON.stringify(data));

    try {
      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });

      console.log("🚀 API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error; // Ensure proper error handling
    }
  },
);

export const postWeightage = createAsyncThunk(
  "allScreen/Header",
  async ({ Type, data }, { rejectWithValue }) => {
    const url = store.getState().globalurl.weightagepostUrl;

    const payload = { Type, data };

    console.log("🚀 Request Payload:", JSON.stringify(payload));

    try {
      const response = await axios.post(url, payload, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });

      console.log("🚀 API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  },
);

export const explorePostData = createAsyncThunk(
  "allScreen/post/explore",
  async ({ accessID, action, idata }) => {
    const url = store.getState().globalurl.apiUrl;
    const data = {
      accessid: accessID,
      action: action,
      data: idata,
    };

    console.log("post" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

export const PackingListPostData = createAsyncThunk(
  "packinglist/post",
  async ({ accessID, action, idata, Type }) => {
    const url = store.getState().globalurl.apiUrl;
    const data = {
      accessid: accessID,
      action: action,
      data: idata,
      type: Type,
    };

    console.log("post" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    // console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  },
);

export const getVersionBom = createAsyncThunk(
  "product/bom",
  async ({ recID }) => {
    var url = store.getState().globalurl.commonUrl;
    var data = {
      recid: recID,
      action: "get",
      accessid: "",
    };

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: Formapireducer.js:314 ~ response:", response);
    return response.data;
  },
);
export const getVersionJobworkBom = createAsyncThunk(
  "jobwork/bom",
  async ({ recID }) => {
    var url = store.getState().globalurl.jobworkbomurl;
    var data = {
      recid: recID,
      action: "get",
      accessid: "",
    };

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: Formapireducer.js:314 ~ response:", response);
    return response.data;
  },
);
export const hashtoken = createAsyncThunk(
  "hashtoken/data",
  async ({ hashtoken }) => {
    var url = store.getState().globalurl.decryptUrl;
    console.log("Tokeeeeennn", hashtoken);

    const response = await axios.post(url, hashtoken, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    //alert("response",response);
    console.log("🚀 ~ file: Formapireducer.js:314 ~ response:", response);
    return response.data;
  },
);

export const Inventorygrid1 = createAsyncThunk(
  "Inv1/Itemgroup",
  async ({ AccessID, VerticalLicense, screenName, filter, any }, { getState }) => {
    const url = getState().globalurl.listViewurl;

    const CompId = sessionStorage.getItem("compID");

    const idata = {
      Query: {
        AccessID,
        VerticalLicense: VerticalLicense,
        ScreenName: screenName,
        Filter: filter,
        Any: any,
        CompId,
      },
    };

    const response = await axios.get(url, {
      params: { data: JSON.stringify(idata) },
      headers: {
        Authorization: "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });

    return response.data; // returning full response
  }
);
export const Inventorygrid2 = createAsyncThunk(
  "Inv2/Itemcategory",
  async ({ AccessID, VerticalLicense, screenName, filter, any }, { getState }) => {
    const url = getState().globalurl.listViewurl;

    const CompId = sessionStorage.getItem("compID");

    const idata = {
      Query: {
        AccessID,
        VerticalLicense: VerticalLicense,
        ScreenName: screenName,
        Filter: filter,
        Any: any,
        CompId,
      },
    };

    const response = await axios.get(url, {
      params: { data: JSON.stringify(idata) },
      headers: {
        Authorization: "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });

    return response.data; // returning full response
  }
);
export const Inventorygrid3 = createAsyncThunk(
  "Inv3/Item",
  async ({ AccessID, VerticalLicense, screenName, filter, any }, { getState }) => {
    const url = getState().globalurl.listViewurl;

    const CompId = sessionStorage.getItem("compID");

    const idata = {
      Query: {
        AccessID,
        VerticalLicense: VerticalLicense,
        ScreenName: screenName,
        Filter: filter,
        Any: any,
        CompId,
      },
    };

    const response = await axios.get(url, {
      params: { data: JSON.stringify(idata) },
      headers: {
        Authorization: "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });

    return response.data; // returning full response
  }
);
export const getBomList = createAsyncThunk(
  "listOfBom/getbom",
  async ({ recid, action, ProductID }) => {
    const url = store.getState().globalurl.bomHeaderUrl;
    const data = {
      recid,
      action,
      ProductID,
    };

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: Formapireducer.js:314 ~ response:", response);
    return response.data;
  },
);
export const postPrdBthData = createAsyncThunk(
  "product/bom",
  async ({ data }) => {
    var url = store.getState().globalurl.prdCardBthUrl;
    console.log(
      "🚀 ~ file: Formapireducer.js:334 ~ data:",
      JSON.stringify(data),
    );
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: Formapireducer.js:314 ~ response:", response);
    return response.data;
  },
);
export const getDCTracking = createAsyncThunk(
  "Deliverychalan/tracking",
  async ({ idata }) => {
    var url = store.getState().globalurl.dcTrackingUrl;
    var data = {
      ...idata,
    };
    console.log(
      "🚀 ~ file: Formapireducer.js:334 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: Formapireducer.js:345 ~ response:", response);
    return response.data;
  },
);
export const proPriceTracking = createAsyncThunk(
  "Product/Price Tracking",
  async ({ idata }) => {
    var url = store.getState().globalurl.producttrackingUrl;
    var data = {
      ...idata,
    };
    console.log(
      "🚀 ~ file: Formapireducer.js:334 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: Formapireducer.js:345 ~ response:", response);
    return response.data;
  },
);

export const setReg = createAsyncThunk(
  "Regularization/Price Tracking",
  async ({ params }) => {
    console.log("Dispatch received idata:", params);
    // var url = store.getState().globalurl.producttrackingUrl;
    var data = {
      ...params,
    };
    // setAssignparams(params.rows);
    console.log(
      "🚀 ~ file: Formapireducer.js:334 ~ data:",
      JSON.stringify(data),
    );

    // const response = await axios.post(url, data, {
    //   headers: {
    //     Authorization:
    //       "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
    //   },
    // });
    // console.log("🚀 ~ file: Formapireducer.js:345 ~ reg:", response)
    // return response.data;
  },
);

// export function customerorderanalysis(RecordID,CompanyID,YearID) {
//   return async (dispatch) => {
//     function onSuccess(success) {
//        console.log("chartData---" +JSON.stringify(success));
//       // const datawait = dispatch(
//       //   stockReqSuccess({
//       //     stockReqapiResponse: success.data.Data,
//       //   })
//       // );
//       return success.data.Data;
//     }
//     function onError(error) {
//       //dispatch({ type: ERROR_GENERATED, error });
//       return error;
//     }
//     try {
//       var url = store.getState().globalurl.customerorderanalysisUrl;

//       var data = {
//         Query: {
//           RecordID: RecordID,
//           CompanyID:CompanyID,
//           Finyear:YearID
//         },
//       };
//       data = JSON.stringify(data);
//       // console.log("---"+url);
//       dispatch(pending());

//       const success = await axios.get(url, {
//         params: {
//           data: data,
//         },
//         headers: {
//           Authorization:
//             "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
//         },
//       });
//        console.log("chart Response---" + JSON.stringify(success));
//       return onSuccess(success);
//     } catch (error) {
//       return onError(error);
//     }
//   };
// }

export const customerorderanalysis = createAsyncThunk(
  "Customer Order/Analysis",
  async ({ data }) => {
    var url = store.getState().globalurl.customerorderanalysisUrl;

    console.log(
      "🚀 ~ file: Formapireducer.js:334 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.get(url, {
      params: {
        data: JSON.stringify(data),
      },
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log("🚀 ~ file: Formapireducer.js:345 ~ response:", response);
    return response.data;
  },
);
export const productorderanalysis = createAsyncThunk(
  "Product Order/Analysis",
  async ({ data }) => {
    var url = store.getState().globalurl.prductorderanalysisUrl;

    console.log(
      "🚀 ~ file: Formapireducer.js:334 ~ data:",
      JSON.stringify(data),
    );

    const response = await axios.get(url, {
      params: {
        data: JSON.stringify(data),
      },
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log("🚀 ~ file: Formapireducer.js:345 ~ response:", response);
    return response.data;
  },
);
export const InvoiceAnalyticsget = createAsyncThunk(
  "Mgr_Desk/invoice_analytics_get",
  async (data, { rejectWithValue }) => {
    try {
      const url = store.getState().globalurl.InvoiceAnalytics;

      const payload = {
        CompanyID: data.CompanyID,
        CategoryID: data.CategoryID,
        staffID: data.staffID,
        fromPeriod: data.fromPeriod,
        toPeriod: data.toPeriod,
      };

      console.log(" THUNK CALLED:", payload);
      console.log(" URL:", url);

      const response = await axios.post(url, payload, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });

      console.log(" API RESPONSE:", response.data);

      return response.data;
    } catch (error) {
      console.error(" API ERROR:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const TeacherOccupancyget = createAsyncThunk(
  "Mgr_Desk/TeacherOccupancy",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const url = getState().globalurl.TeacherOccupancy;

      const response = await axios.post(url, payload, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });

      console.log("API RESPONSE:", response.data);

      return response.data;
    } catch (error) {
      console.error("API ERROR:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const TimetableProcessController = createAsyncThunk(
  "TimetableProcess/Get",
  async ({ data }) => {
    var url = store.getState().globalurl.TimetableProcessController;

    const payload =
    {
      HeaderID: data.HeaderID,
      TeacherID: data.TeacherID,
      Process: data.Process,
      Reason: data.Reason
    }
    const response = await axios.post(url, payload, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const PublishEvent = createAsyncThunk(
  "PublishEvent/Post",
  async ({ data }) => {
    var url = store.getState().globalurl.PublishEventController;

    const payload =
    {
      CompanyID: data.CompanyID,
      EventCategoryID: data.EventCategoryID,
    }
    const response = await axios.post(url, payload, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const TimeTableGenerateget = createAsyncThunk(
  "Standard/TimeTableGenerateget",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const url = getState().globalurl.TimeTableGenerateget;

      const response = await axios.post(url, payload, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });

      console.log("API RESPONSE:", response.data);

      return response.data;
    } catch (error) {
      console.error("API ERROR:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const TimeTableDelete = createAsyncThunk(
  "Standard/TimeTableDelete",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const url = getState().globalurl.TimeTableDelete;

      const response = await axios.post(url, payload, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });

      console.log("API RESPONSE:", response.data);

      return response.data;
    } catch (error) {
      console.error("API ERROR:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const FeesStructureDelete = createAsyncThunk(
  "Standard/FeesStructureDelete",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const url = getState().globalurl.FeesStructureDelete;

      const response = await axios.post(url, payload, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });

      console.log("API RESPONSE:", response.data);

      return response.data;
    } catch (error) {
      console.error("API ERROR:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);



export const standardDelete = createAsyncThunk(
  "Standard_activities/standardDelete",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const url = getState().globalurl.standardDeleteUrl;

      const response = await axios.post(url, payload, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });

      console.log("API RESPONSE:", response.data);

      return response.data;
    } catch (error) {
      console.error("API ERROR:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const companyTermsGet = createAsyncThunk(
  "COMPANY_TERMS_GET/GET",
  async ({ CompanyID }) => {
    var url = store.getState().globalurl.CompanyTermsGet;
    const data = {
      CompanyID: CompanyID,
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data)
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);

// SLOT_GET_FUNCTION

export const SlotGetfunction = createAsyncThunk(
  "Slots_GET/GET",
  async ({ GroupID }) => {
    var url = store.getState().globalurl.slotgetUrl;
    const data = {
      GroupID: GroupID,
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data)
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
// Company -- Policy Get
export const PolicyFetchData = createAsyncThunk(
  "PolicyFetchData/get",
  async ({ get, CompanyID }) => {
    var url = store.getState().globalurl.CompanyPloicyGET;
    const data = {
      get: get,
      CompanyID: CompanyID,
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:225 ~ data:",
      JSON.stringify(data)
    );

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);

export const PolicyUpdateData = createAsyncThunk(
  "PolicyUpdateData/update",
  async ({ idata }) => {
    const url = store.getState().globalurl.CompanyPolicyUpdate;


    const data = idata;

    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const getApiSlice = createSlice({
  name: "formApi",
  initialState,
  reducers: {
    resetTrackingData(state) {
      state.itemstockDataAnalytics = [];
      state.trackingData = [];
      state.customerData = {};
      state.productanalysisData = {};
      state.summeryData = [];
      state.stockorderData = [];
      state.purchaseorderratingData = [];
      state.empAttendanceData = [];
      state.InventrygetData = [];
      state.payslipAttendanceData = [];
      state.AttendanceData = [];
      state.timeSheetData = [];
      state.MonthlyAttendanceData = [];
      state.costingLeatherCost.leatherOneCost = 0;
      state.costingLeatherCost.leatherTwoCost = 0;
      state.costingLeatherCost.leatherThreeCost = 0;
      state.costingLeatherCost.materialCost = 0;
      state.costingLeatherCost.latestmaterialCost = 0;
      state.costingLeatherCost.latestleatherOneCost = 0;
      state.costingLeatherCost.latestleatherTwoCost = 0;
      state.costingLeatherCost.latestleatherThreeCost = 0;
    },
    resetPartyAnalyticsdata(state) {
      state.PartyAnalyticsdata = {};
    },
    resetTimeSheetAttendance(state) {
      state.timeSheetData = [];
    },
    ratingChange(state, action) {
      const index = [...action.payload.rowdata].findIndex(
        (value) => value.RecordID === action.payload.id,
      );
      action.payload.rowdata[index] = action.payload.rating;
      state.purchaseorderratingData = action.payload.rowdata;
    },
    packingListCarton(state, action) {
      console.log(
        "🚀 ~ file: Formapireducer.js:502 ~ packingListCarton ~ action:",
        action,
      );
      console.log("action called");
      switch (action.payload.type) {
        case "INSERTED":
          state.pakingListCarton.push(...action.payload.data);
          break;
        case "EDITED":
          state.pakingListCarton = action.payload.data;
          break;
        case "RESET":
          state.pakingListCarton = [];
          break;
      }
    },
    pending(state) {
      return {
        ...state,
        loading: true,
        error: false,
        Data: {},
      };
    },
    errored(state, action) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
    Success(state, action) {
      if (action.payload.action == "get") {
        return {
          ...state,
          loading: false,
          error: "",
          Data: action.payload.apiResponse,
        };
      } else {
        return {
          ...state,
          loading: false,
          error: "",
          Data: action.payload.apiResponse,
          Status: action.payload.Status,
          msg: action.payload.Msg,
          Successflag: true,
        };
      }
    },
    stockSuccess(state, action) {
      return {
        ...state,
        stockValue: action.payload.stockapiResponse,
      };
    },
    stockReqSuccess(state, action) {
      return {
        ...state,

        stockReqData: action.payload.stockReqapiResponse,
      };
    },
    userGroupUpdate(state, action) {
      state.userGroup = action.payload.rowData;
    },
    resetregularizedata(state, action) {
      state.RegGetData = {
        RecordID: "",
        EmployeeID: "",
        EmployeeName: "",
        CheckInDate: "",
        CheckOutDate: "",
        CheckInType: "",
        CheckInTime: "",
        CheckOutTime: "",
        Status: "",
        Remarks: "",
        Date: "",
        Reason: "",
        ManagerComments: "",
        AppliedStatus: "",
      };
    },
    clearData: (state, action) => {
      state.Data = {};
      state.AutogeneraterowData = [];
      state.AutogeneratecolumnData = [];
      state.breakSlots = [];
      state.Status = "";
      state.loading = false;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(invoiceHeaderGetData.pending, (state, action) => {
        state.Status = "idle";
        state.loading = true;
      })
      .addCase(invoiceHeaderGetData.fulfilled, (state, action) => {
        state.Status = "success";
        state.loading = false;
        if (action.payload.Data.Disable == "Y") {
          action.payload.Data.Disable = true;
        } else action.payload.Data.Disable = false;

        state.Data = action.payload.Data;
      })
      .addCase(invoiceHeaderGetData.rejected, (state, action) => {
        state.Status = "Error";
        state.loading = false;
      })
      .addCase(batchreconciliationGetData.pending, (state, action) => {
        state.Status = "idle";
        state.loading = true;
      })
      .addCase(batchreconciliationGetData.fulfilled, (state, action) => {
        state.Status = "success";
        state.loading = false;
        if (action.payload.Data.Disable == "Y") {
          action.payload.Data.Disable = true;
        } else action.payload.Data.Disable = false;

        state.Data = action.payload.Data;
      })
      .addCase(batchreconciliationGetData.rejected, (state, action) => {
        state.Status = "Error";
        state.loading = false;
      })
      .addCase(invoiceExploreGetData.pending, (state, action) => {
        state.Status = "idle";
        state.expgetLoading = true;
      })
      .addCase(invoiceExploreGetData.fulfilled, (state, action) => {
        state.Status = "success";
        //  state.loading = false
        if (action.payload.Data.Disable == "Y") {
          action.payload.Data.Disable = true;
        } else action.payload.Data.Disable = false;
        state.expgetLoading = false;
        state.inviceEData = action.payload.Data;
      })
      .addCase(invoiceExploreGetData.rejected, (state, action) => {
        state.Status = "Error";
        state.expgetLoading = false;
      })

      .addCase(InvoicePostData.pending, (state, action) => {
        state.Status = "idle";
        state.postLoading = true;
      })
      .addCase(InvoicePostData.fulfilled, (state, action) => {
        state.Status = "success";
        state.postLoading = false;
        if (action.meta.arg.idata.Disable == "Y") {
          action.meta.arg.idata.Disable = true;
        } else action.meta.arg.idata.Disable = false;
        if (action.meta.arg.accessID !== "TR012") {
          state.data = action.meta.arg.idata;
        }
      })
      .addCase(InvoicePostData.rejected, (state, action) => {
        state.Status = "Error";
        state.postLoading = false;
      })
      .addCase(InvoiceAnalyticsget.pending, (state) => {
        state.invoiceAnalyticsLoading = true;
        state.invoiceAnalyticsError = null;
        state.invoiceAnalyticsData = null;
      })
      .addCase(InvoiceAnalyticsget.fulfilled, (state, action) => {
        state.invoiceAnalyticsLoading = false;
        state.invoiceAnalyticsData = action.payload; // full API response
        state.invoiceAnalyticsError = null;
      })
      .addCase(InvoiceAnalyticsget.rejected, (state, action) => {
        state.invoiceAnalyticsLoading = false;
        state.invoiceAnalyticsError = action.payload || "Failed to fetch invoice analytics";
        state.invoiceAnalyticsData = null;
      })
      //SLOTS_GET_addcase
      .addCase(SlotGetfunction.pending, (state, action) => {
        state.slotStatus = "idle";
        state.slotLoading = true;
        state.slotgetData = [];
        state.msg = "Loading...";
      })
      .addCase(SlotGetfunction.fulfilled, (state, action) => {
        console.log("🔥SlotGetfunction  FULL PAYLOAD:", action.payload);
        state.slotStatus = "success";
        state.slotLoading = false;
        state.slotgetData = action.payload.Data ? action.payload.Data : [];
        // state.msg =  action.payload.Msg
      })
      .addCase(SlotGetfunction.rejected, (state, action) => {
        state.slotStatus = "Error";
        state.slotLoading = false;
        state.slotgetData = [];
        toast.error("Something Went Wrong");
      })



      //COMPANY_TERMS_GET
      .addCase(companyTermsGet.pending, (state, action) => {
        state.companytermsStatus = "idle";
        state.companytermsgetLoading = true;
        state.companytermsData = [];
        state.msg = "Loading...";
      })
      .addCase(companyTermsGet.fulfilled, (state, action) => {
        state.companytermsStatus = "success";
        state.companytermsgetLoading = false;
        state.companytermsData = action.payload.Data ? action.payload.Data : [];
        // state.msg =  action.payload.Msg
      })
      .addCase(companyTermsGet.rejected, (state, action) => {
        state.companytermsStatus = "Error";
        state.companytermsgetLoading = false;
        state.companytermsData = [];
        toast.error("Something Went Wrong");
      })

      //COMPANY_POLICY_GET

      .addCase(PolicyFetchData.pending, (state, action) => {
        state.PolicyStatus = "idle";
        state.PolicygetLoading = true;
        state.PolicyData = {};
        state.msg = "Loading...";
      })
      .addCase(PolicyFetchData.fulfilled, (state, action) => {
        state.PolicyStatus = "success";
        state.PolicygetLoading = false;
        state.PolicyData = action.payload.Data ? action.payload.Data : {};
        // state.msg =  action.payload.Msg
      })
      .addCase(PolicyFetchData.rejected, (state, action) => {
        state.PolicyStatus = "Error";
        state.PolicygetLoading = false;
        state.PolicyData = {};
        toast.error("Something Went Wrong");
      })
      .addCase(ModuleUrl.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(ModuleUrl.fulfilled, (state, action) => {
        state.status = "succeeded";

        // Store the API response (ensure your API returns an array)
        state.data = action.payload || [];
      })
      .addCase(ModuleUrl.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        state.data = [];
      })
      .addCase(InvoicePostExploreData.pending, (state, action) => {
        state.Status = "idle";
        state.loading = true;
      })
      .addCase(InvoicePostExploreData.fulfilled, (state, action) => {
        if (action.meta.arg.idata.Disable == "Y") {
          action.meta.arg.idata.Disable = true;
        } else action.meta.arg.idata.Disable = false;
        state.inviceEData = action.meta.arg.idata;
        state.loading = false;
      })
      .addCase(InvoicePostExploreData.rejected, (state, action) => {
        state.Status = "Error";
        state.loading = false;
      })

      .addCase(getFetchFeeData.pending, (state, action) => {
        state.Status = "idle";
        state.getLoading = true;
        state.msg = "Loading...";
      })
      .addCase(getFetchFeeData.fulfilled, (state, action) => {
        state.Status = "success";
        state.getLoading = false;
        state.Data = action.payload.Data ? action.payload.Data : {};
        // state.msg =  action.payload.Msg
      })
      .addCase(getFetchFeeData.rejected, (state, action) => {
        state.Status = "Error";
        state.getLoading = false;
        // toast.error("Something Went Wrong");
      })
      

      .addCase(getFetchCashData.pending, (state, action) => {
        state.Status = "idle";
        state.getLoading = true;
        state.msg = "Loading...";
      })
      .addCase(getFetchCashData.fulfilled, (state, action) => {
        state.Status = "success";
        state.getLoading = false;
        state.Data = action.payload.Data ? action.payload.Data : {};
        // state.msg =  action.payload.Msg
      })
      .addCase(getFetchCashData.rejected, (state, action) => {
        state.Status = "Error";
        state.getLoading = false;
        // toast.error("Something Went Wrong");
      })
      .addCase(getFetchData_v1.pending, (state) => {
        state.Status = "idle";
        state.getLoading = true;
        state.msg = "Loading...";
      })
 
      .addCase(getFetchData_v1.fulfilled, (state, action) => {
        console.log("API SUCCESS", action.payload);
        state.Status = "success";
        state.getLoading = false;
        state.Data = action.payload?.Data || {};
        state.Department = action.payload || [];
        console.log(action.payload, "------getfetch department in formapi");
       
      })
 
      .addCase(getFetchData_v1.rejected, (state) => {
        state.Status = "Error";
        state.getLoading = false;
        toast.error("Something Went Wrong");
      })
      .addCase(getFetchData.pending, (state) => {
        state.Status = "idle";
        state.getLoading = true;
        state.msg = "Loading...";
      })

      .addCase(getFetchData.fulfilled, (state, action) => {
        console.log("API SUCCESS", action.payload);
        state.Status = "success";
        state.getLoading = false;
        state.Data = action.payload?.Data || {};
      })

      .addCase(getFetchData.rejected, (state) => {
        state.Status = "Error";
        state.getLoading = false;
        toast.error("Something Went Wrong");
      })
      .addCase(EventsgetData.pending, (state) => {
        state.Status = "idle";
        state.getLoading = true;
        state.msg = "Loading...";
      })

      .addCase(EventsgetData.fulfilled, (state, action) => {
        console.log("API SUCCESS", action.payload);
        state.Status = "success";
        state.getLoading = false;
        state.Data = action.payload?.Data || {};
      })

      .addCase(EventsgetData.rejected, (state) => {
        state.Status = "Error";
        state.getLoading = false;
        toast.error("Something Went Wrong");
      })
      //PartyBank Details GET

      .addCase(PartyBankget.pending, (state, action) => {
        state.partyBankgetstatus = "idle";
        // state.partyBankgetloading = true;
        state.partyBankgetdata = {};
        // state.msg = "Loading..."
      })
      .addCase(PartyBankget.fulfilled, (state, action) => {
        state.partyBankgetstatus = "success";
        // state.partyBankgetloading = false;
        state.partyBankgetdata = action.payload.Data ? action.payload.Data : {};
        // state.msg =  action.payload.Msg
      })
      .addCase(PartyBankget.rejected, (state, action) => {
        state.partyBankgetstatus = "Error";
        // state.partyBankgetloading = false;
        state.partyBankgetdata = {};
        // toast.error('Something Went Wrong')
      })

      .addCase(PartyContactget.pending, (state, action) => {
        state.partyBankgetstatus = "idle";
        state.partyContactgetdata = {};
      })
      .addCase(PartyContactget.fulfilled, (state, action) => {
        state.partyBankgetstatus = "success";
        state.partyContactgetdata = action.payload.Data
          ? action.payload.Data
          : {};
      })
      .addCase(PartyContactget.rejected, (state, action) => {
        state.partyBankgetstatus = "Error";
        state.partyContactgetdata = {};
      })

      //Partbank POST
      .addCase(partyBankpostData.pending, (state, action) => {
        state.Status = "idle";
        state.postLoading = true;
      })
      .addCase(partyBankpostData.fulfilled, (state, action) => {
        state.Status = "success";
        state.postLoading = false;
        // if (action.meta.arg.idata.Disable == "Y") {
        //   action.meta.arg.idata.Disable = true;
        // } else action.meta.arg.idata.Disable = false;

        state.partyBankPostdata = action.meta.arg.idata;
        console.log(action.meta.arg.idata, "--partyBankPostdata");
      })

      .addCase(partyBankpostData.rejected, (state, action) => {
        state.Status = "Error";
        state.postLoading = false;
      })

      .addCase(partyContactData.pending, (state, action) => {
        state.Status = "idle";
        state.postLoading = true;
      })
      .addCase(partyContactData.fulfilled, (state, action) => {
        state.Status = "success";
        state.postLoading = false;
        // if (action.meta.arg.idata.Disable == "Y") {
        //   action.meta.arg.idata.Disable = true;
        // } else action.meta.arg.idata.Disable = false;
        state.partyContactData = action.meta.arg.idata;
        console.log(action.meta.arg.idata, "--partyBankPostdata");
      })
      .addCase(partyContactData.rejected, (state, action) => {
        state.Status = "Error";
        state.postLoading = false;
      })
      //VENDOR - REGISTRATION
      .addCase(VendorRegisterpostData.pending, (state, action) => {
        state.Status = "idle";
        state.postLoading = true;
      })
      .addCase(VendorRegisterpostData.fulfilled, (state, action) => {
        state.Status = "success";
        state.postLoading = false;
        state.partyContactData = action.meta.arg.idata;
      })
      .addCase(VendorRegisterpostData.rejected, (state, action) => {
        state.Status = "Error";
        state.postLoading = false;
      })

      //VENDOR - DEFAULT
      .addCase(VendorDefaultPUTdata.pending, (state, action) => {
        state.Status = "idle";
        state.postLoading = true;
      })
      .addCase(VendorDefaultPUTdata.fulfilled, (state, action) => {
        state.Status = "success";
        state.postLoading = false;
        state.partyContactData = action.meta.arg.idata;
      })
      .addCase(VendorDefaultPUTdata.rejected, (state, action) => {
        state.Status = "Error";
        state.postLoading = false;
      })
      //ITEM MAIN - POST
      .addCase(ItemMainpostData.pending, (state, action) => {
        state.Status = "idle";
        state.postLoading = true;
      })
      .addCase(ItemMainpostData.fulfilled, (state, action) => {
        state.Status = "success";
        state.postLoading = false;
        state.Data = action.meta.arg.idata;
      })
      .addCase(ItemMainpostData.rejected, (state, action) => {
        state.Status = "Error";
        state.postLoading = false;
      })
      //ITEM FLAG - POST
      .addCase(ItemFlagPostdata.pending, (state, action) => {
        state.Status = "idle";
        state.postLoading = true;
      })
      .addCase(ItemFlagPostdata.fulfilled, (state, action) => {
        state.Status = "success";
        state.postLoading = false;
        state.Data = action.meta.arg.idata;
      })
      .addCase(ItemFlagPostdata.rejected, (state, action) => {
        state.Status = "Error";
        state.postLoading = false;
      })
      //ITEM FLAG - POST
      .addCase(ItemFlagMenuPut.pending, (state, action) => {
        state.Status = "idle";
        state.postLoading = true;
      })
      .addCase(ItemFlagMenuPut.fulfilled, (state, action) => {
        state.Status = "success";
        state.postLoading = false;
        state.Data = action.meta.arg.idata;
      })
      .addCase(ItemFlagMenuPut.rejected, (state, action) => {
        state.Status = "Error";
        state.postLoading = false;
      })
      //ITEM STOCK - POST
      .addCase(ItemStockMenuPut.pending, (state, action) => {
        state.Status = "idle";
        state.postLoading = true;
      })
      .addCase(ItemStockMenuPut.fulfilled, (state, action) => {
        state.Status = "success";
        state.postLoading = false;
        state.Data = action.meta.arg.idata;
      })
      .addCase(ItemStockMenuPut.rejected, (state, action) => {
        state.Status = "Error";
        state.postLoading = false;
      })

      //ORDER HEADER - PAYMENT UPDATE
      .addCase(OHPaymentUpdateController.pending, (state, action) => {
        state.OHPaymentPutstatus = "idle";
        state.OHPaymentPutloading = true;
      })
      .addCase(OHPaymentUpdateController.fulfilled, (state, action) => {
        state.OHPaymentPutstatus = "success";
        state.OHPaymentPutloading = false;
        state.OHPaymentPutdata = action.meta.arg.idata;
      })
      .addCase(OHPaymentUpdateController.rejected, (state, action) => {
        state.OHPaymentPutstatus = "Error";
        state.OHPaymentPutloading = false;
      })

      //PARTY - SORT FILTER GET
      .addCase(PartyBydateByamtFilter.pending, (state, action) => {
        state.PartyDateAndAmtFilterstatus = "idle";
        state.PartyDateAndAmtFilterloading = true;
      })
      .addCase(PartyBydateByamtFilter.fulfilled, (state, action) => {
        state.PartyDateAndAmtFilterstatus = "success";
        state.PartyDateAndAmtFilterloading = false;
        state.PartyDateAndAmtFilterdata = action.payload.Data
          ? action.payload.Data
          : [];
      })
      .addCase(PartyBydateByamtFilter.rejected, (state, action) => {
        state.PartyDateAndAmtFilterstatus = "Error";
        state.PartyDateAndAmtFilterloading = false;
      })

      //PAYSLIP - GET
      .addCase(paySlipGet.pending, (state, action) => {
        state.paySlipstatus = "idle";
        state.paySliploading = true;
      })
      .addCase(paySlipGet.fulfilled, (state, action) => {
        state.paySlipstatus = "success";
        state.paySliploading = false;
        state.paySlipdata = action.payload.data
          ? action.payload.data
          : [];
      })
      .addCase(paySlipGet.rejected, (state, action) => {
        state.paySlipstatus = "Error";
        state.paySliploading = false;
      })
      //ORDER ITEM --> REPLACEMENT QTY - GET
      .addCase(replacementQtyGet.pending, (state, action) => {
        state.replacementQtyGetstatus = "idle";
        state.replacementQtyGetloading = true;
      })
      .addCase(replacementQtyGet.fulfilled, (state, action) => {
        state.replacementQtyGetstatus = "success";
        state.replacementQtyGetloading = false;
        state.replacementQtyGetdata = action.payload.Data
          ? action.payload.Data
          : {};
      })
      .addCase(replacementQtyGet.rejected, (state, action) => {
        state.replacementQtyGetstatus = "Error";
        state.replacementQtyGetloading = false;
      })

      //PARTY - SORT FILTER GET
      .addCase(leaveenquiryget.pending, (state, action) => {
        state.LeaveEntryRegstatus = "idle";
        state.LeaveEntryRegloading = true;
      })
      .addCase(leaveenquiryget.fulfilled, (state, action) => {
        state.LeaveEntryRegstatus = "success";
        state.LeaveEntryRegloading = false;
        state.LeaveEntryRegdata = action.payload.Data
          ? action.payload.Data
          : [];
      })
      .addCase(leaveenquiryget.rejected, (state, action) => {
        state.LeaveEntryRegstatus = "Error";
        state.LeaveEntryRegloading = false;
      })
      // Inventorygrid1
      .addCase(Inventorygrid1.pending, (state) => {
        state.Inventorygrid1loading = true;
        state.Inventorygrid1status = "loading";
      })

      .addCase(Inventorygrid1.fulfilled, (state, action) => {
        state.Inventorygrid1loading = false;
        state.Inventorygrid1status = "success";

        state.Inventorygrid1columns =
          action.payload?.Data?.columns || [];

        state.Inventorygrid1rows =
          action.payload?.Data?.rows || [];
      })

      .addCase(Inventorygrid1.rejected, (state) => {
        state.Inventorygrid1loading = false;
        state.Inventorygrid1status = "error";
      })
      // Inventorygrid2
      .addCase(Inventorygrid2.pending, (state) => {
        state.Inventorygrid2loading = true;
        state.Inventorygrid2status = "loading";
      })

      .addCase(Inventorygrid2.fulfilled, (state, action) => {
        state.Inventorygrid2loading = false;
        state.Inventorygrid2status = "success";

        state.Inventorygrid2columns =
          action.payload?.Data?.columns || [];

        state.Inventorygrid2rows =
          action.payload?.Data?.rows || [];
      })

      .addCase(Inventorygrid2.rejected, (state) => {
        state.Inventorygrid2loading = false;
        state.Inventorygrid2status = "error";
      })
      // Inventorygrid3
      .addCase(Inventorygrid3.pending, (state) => {
        state.Inventorygrid3loading = true;
        state.Inventorygrid3status = "loading";
      })

      .addCase(Inventorygrid3.fulfilled, (state, action) => {
        state.Inventorygrid3loading = false;
        state.Inventorygrid3status = "success";

        state.Inventorygrid3columns =
          action.payload?.Data?.columns || [];

        state.Inventorygrid3rows =
          action.payload?.Data?.rows || [];
      })

      .addCase(Inventorygrid3.rejected, (state) => {
        state.Inventorygrid3loading = false;
        state.Inventorygrid3status = "error";
      })

      .addCase(EmployeeVendorGetController.pending, (state, action) => {
        state.Partygetstatus = "idle";
        state.Partygetloading = true;
      })
      .addCase(EmployeeVendorGetController.fulfilled, (state, action) => {
        state.Partygetstatus = "success";
        state.Partygetloading = false;
        state.Partygetdata = action.payload.Data
          ? action.payload.Data
          : [];
      })
      .addCase(EmployeeVendorGetController.rejected, (state, action) => {
        state.Partygetstatus = "Error";
        state.Partygetloading = false;
      })

      .addCase(EmployeeVendorContactGet.pending, (state, action) => {
        state.Partycontactgetstatus = "idle";
        state.Partycontactgetloading = true;
      })
      .addCase(EmployeeVendorContactGet.fulfilled, (state, action) => {
        state.Partycontactgetstatus = "success";
        state.Partycontactgetloading = false;
        state.Partycontactgetdata = action.payload.Data
          ? action.payload.Data
          : [];
      })
      .addCase(EmployeeVendorContactGet.rejected, (state, action) => {
        state.Partycontactgetstatus = "Error";
        state.Partycontactgetloading = false;
      })

      //SprintGet
      .addCase(sprintGetData.pending, (state, action) => {
        state.sprintgetstatus = "idle";
        // state.sprintloading = true;
        state.sprintget = {};
        // state.msg =  "Loading..."
      })
      .addCase(sprintGetData.fulfilled, (state, action) => {
        state.sprintgetstatus = "success";
        // state.sprintloading = false;
        state.sprintget = action.payload.Data
          ? action.payload.Data.headerData
          : {};
        state.sprintPPget = action.payload.Data.detailData;
        // state.msg =  action.payload.Msg
        console.log(state.sprintPPget, "--sprintGetData state.sprintPPget");
      })

      .addCase(sprintGetData.rejected, (state, action) => {
        state.sprintgetstatus = "Error";
        // state.sprintloading = false;
        state.sprintget = [];
        //  toast.error('Something Went Wrong')
      })
      //Sprint PP GET
      .addCase(sprintprojectplanGetData.pending, (state, action) => {
        // state.sprintgetstatus = "idle";
        state.sprintloading = true;
        state.sprintPPget = [];
        // state.msg =  "Loading..."
      })
      .addCase(sprintprojectplanGetData.fulfilled, (state, action) => {
        // state.sprintgetstatus = "success";
        state.sprintloading = false;
        state.sprintPPget = action.payload.Data ? action.payload.Data : [];
        // state.msg =  action.payload.Msg
        console.log(
          state.sprintPPget,
          "--sprintprojectplanGetData state.sprintPPget",
        );
      })
      .addCase(sprintprojectplanGetData.rejected, (state, action) => {
        // state.sprintgetstatus = "Error";
        state.sprintloading = false;
        state.sprintPPget = [];
        //  toast.error('Something Went Wrong')
      })

      .addCase(getSettingsData.pending, (state, action) => {
        state.Status = "idle";
        state.getLoading = true;
        state.Data = {};
        state.msg = "Loading...";
      })
      .addCase(getSettingsData.fulfilled, (state, action) => {
        state.Status = "success";
        state.getLoading = false;
        state.Data = action.payload.Data ? action.payload.Data : {};
        // state.msg =  action.payload.Msg
      })
      .addCase(getSettingsData.rejected, (state, action) => {
        state.Status = "Error";
        state.getLoading = false;
        state.Data = {};
        toast.error("Something Went Wrong");
      })
      .addCase(getBiometricData.pending, (state, action) => {
        state.Status = "idle";
        state.getLoading = true;
        state.Data = {};
        state.msg = "Loading...";
      })
      .addCase(getBiometricData.fulfilled, (state, action) => {
        state.Status = "success";
        state.getLoading = false;
        state.Data = action.payload.Data ? action.payload.Data : {};
        // state.msg =  action.payload.Msg
      })
      .addCase(getBiometricData.rejected, (state, action) => {
        state.Status = "Error";
        state.getLoading = false;
        state.Data = {};
        toast.error("Something Went Wrong");
      })

      //settings approals get

      .addCase(setttingsApprovalsData.pending, (state, action) => {
        state.Status = "idle";
        state.getLoading = true;
        state.Data = {};
        state.msg = "Loading...";
      })
      .addCase(setttingsApprovalsData.fulfilled, (state, action) => {
        state.Status = "success";
        state.getLoading = false;
        state.Data = action.payload.Data ? action.payload.Data : {};
        // state.msg =  action.payload.Msg
      })
      .addCase(setttingsApprovalsData.rejected, (state, action) => {
        state.Status = "Error";
        state.getLoading = false;
        state.Data = {};
        toast.error("Something Went Wrong");
      })

      .addCase(CustomisedCaptionGet.pending, (state, action) => {
        state.Status = "idle";
        state.getLoading = true;
        state.CustomisedCaptionGetData = {};
        state.msg = "Loading..."
      })
      .addCase(CustomisedCaptionGet.fulfilled, (state, action) => {
        state.Status = "success";
        state.getLoading = false;
        state.CustomisedCaptionGetData = action.payload.Data ? action.payload.Data : {};
        // state.msg =  action.payload.Msg
      })
      .addCase(CustomisedCaptionGet.rejected, (state, action) => {
        state.Status = "Error";
        state.getLoading = false;
        state.CustomisedCaptionGetData = {};
        toast.error('Something Went Wrong')
      })
      // .addCase(Regularizationdata.pending, (state, action) => {
      //   state.Status = "idle";
      //   state.regularizationLoading = true;
      //   state.Data = {};
      //   state.msg =  "Loading..."
      // })
      // .addCase(Regularizationdata.fulfilled, (state, action) => {
      //   state.Status = "success";
      //   state.regularizationLoading = false;
      //   state.Data = action.payload.Data ? action.payload.Data : {} ;
      //   // state.msg =  action.payload.Msg
      // })
      // .addCase(Regularizationdata.rejected, (state, action) => {
      //   state.Status = "Error";
      //   state.regularizationLoading = false;
      //   state.Data = {};
      //  toast.error('Something Went Wrong')
      // })
      .addCase(postData.pending, (state, action) => {
        state.Status = "idle";
        state.postLoading = true;
      })
      .addCase(postData.fulfilled, (state, action) => {
        state.Status = "success";
        state.postLoading = false;
        // if (action.meta.arg.idata.Disable == "Y") {
        //   action.meta.arg.idata.Disable = true;
        // } else action.meta.arg.idata.Disable = false;

        state.Data = action.meta.arg.idata;
      })
      .addCase(postData.rejected, (state, action) => {
        state.Status = "Error";
        state.postLoading = false;
      })
      .addCase(EventspostData.pending, (state, action) => {
        state.Status = "idle";
        state.postLoading = true;
      })
      .addCase(EventspostData.fulfilled, (state, action) => {
        state.Status = "success";
        state.postLoading = false;
        // if (action.meta.arg.idata.Disable == "Y") {
        //   action.meta.arg.idata.Disable = true;
        // } else action.meta.arg.idata.Disable = false;

        state.Data = action.meta.arg.idata;
      })
      .addCase(EventspostData.rejected, (state, action) => {
        state.Status = "Error";
        state.postLoading = false;
      })

      //settingspost

      .addCase(SettingspostData.pending, (state, action) => {
        state.Status = "idle";
        state.postLoading = true;
      })
      .addCase(SettingspostData.fulfilled, (state, action) => {
        state.Status = "success";
        state.postLoading = false;
        // if (action.meta.arg.idata.Disable == "Y") {
        //   action.meta.arg.idata.Disable = true;
        // } else action.meta.arg.idata.Disable = false;

        state.Data = action.meta.arg.idata;
      })
      .addCase(SettingspostData.rejected, (state, action) => {
        state.Status = "Error";
        state.postLoading = false;
      })

      .addCase(explorePostData.pending, (state, action) => {
        state.Status = "idle";
        state.postLoading = true;
      })

      .addCase(explorePostData.fulfilled, (state, action) => {
        state.Status = "success";
        state.postLoading = false;
      })
      .addCase(explorePostData.rejected, (state, action) => {
        state.Status = "Error";
        state.postLoading = false;
      })
      .addCase(dpConversionData.fulfilled, (state, action) => {
        state.conversionData = action.payload;
        // console.log("🚀 ~ file: Formapireducer.js:373 ~ .addCase ~ action:", action)
      })
      .addCase(stockGetData.fulfilled, (state, action) => {
        state.materialStockData = action.payload;
        // console.log("🚀 ~ file: Formapireducer.js:373 ~ .addCase ~ action:", action)
      })
      .addCase(getVersionBom.fulfilled, (state, action) => {
        state.Status = "success";

        state.exploreData = action.payload.Data ? action.payload.Data : "N";
      })
      .addCase(getVersionJobworkBom.fulfilled, (state, action) => {
        state.Status = "success";

        state.exploreData = action.payload.Data ? action.payload.Data : "N";
      })
      .addCase(hashtoken.fulfilled, (state, action) => {
        state.Status = "success";

        state.hashtokenData = action.payload;
      })
      .addCase(getBomList.fulfilled, (state, action) => {
        state.Status = "success";

        state.exploreData = action.payload.Data;
      })
      .addCase(getDCTracking.pending, (state, action) => {
        state.Status = "idle";
        state.loading = true;
      })
      .addCase(getDCTracking.fulfilled, (state, action) => {
        state.Status = "success";
        state.loading = false;
        state.trackingData = action.payload.Data;
        state.summeryData = action.payload.Summary;
      })
      .addCase(getDCTracking.rejected, (state, action) => {
        state.Status = "Error";
        state.loading = false;
      })
      .addCase(proPriceTracking.pending, (state, action) => {
        state.Status = "idle";
        state.loading = true;
      })
      .addCase(proPriceTracking.fulfilled, (state, action) => {
        state.Status = "success";
        state.loading = false;
        state.trackingData = action.payload.Data;
      })
      .addCase(proPriceTracking.rejected, (state, action) => {
        state.Status = "Error";
        state.loading = false;
      })
      /*Regularization*/
      .addCase(setReg.pending, (state, action) => {
        state.Status = "idle";
        state.loading = true;
      })
      .addCase(setReg.fulfilled, (state, action) => {
        state.Status = "success";
        state.loading = false;
        state.trackingData = action.payload.Data;
      })
      .addCase(setReg.rejected, (state, action) => {
        state.Status = "Error";
        state.loading = false;
      })
      .addCase(customerorderanalysis.fulfilled, (state, action) => {
        state.Status = "success";
        state.loading = false;
        state.customerData = action.payload.Data;
      })
      .addCase(productorderanalysis.fulfilled, (state, action) => {
        state.Status = "success";
        state.loading = false;
        state.productanalysisData = action.payload.Data;
      })
      .addCase(uomMaterialRate.fulfilled, (state, action) => {
        state.conversionData = action.payload;
      })
      .addCase(costLeatherData.fulfilled, (state, action) => {
        console.log(
          "🚀 ~ file: Formapireducer.js:863 ~ .addCase ~ action:",
          action,
        );

        if (action.meta.arg.LeatherNumber == 1) {
          state.costingLeatherCost.leatherOneCost = Number(
            action.payload.LeatherCost,
          ).toFixed(2);
          state.costingLeatherCost.latestleatherOneCost = Number(
            action.payload.LeatherLatestCost,
          ).toFixed(2);
        }
        if (action.meta.arg.LeatherNumber == 2) {
          state.costingLeatherCost.leatherTwoCost = Number(
            action.payload.LeatherCost,
          ).toFixed(2);
          state.costingLeatherCost.latestleatherTwoCost = Number(
            action.payload.LeatherLatestCost,
          ).toFixed(2);
        }
        if (action.meta.arg.LeatherNumber == 3) {
          state.costingLeatherCost.leatherThreeCost = Number(
            action.payload.LeatherCost,
          ).toFixed(2);
          state.costingLeatherCost.latestleatherThreeCost = Number(
            action.payload.LeatherLatestCost,
          ).toFixed(2);
        }
      })
      .addCase(costingBOMData.fulfilled, (state, action) => {
        state.costingLeatherCost.materialCost = Number(
          action.payload.Cost,
        ).toFixed(2);
        state.costingLeatherCost.latestmaterialCost = Number(
          action.payload.LatestCost,
        ).toFixed(2);
      })
      .addCase(customerLeather.fulfilled, (state, action) => {
        state.customerLeatherData = action.payload;
      })
      .addCase(dcSummary.fulfilled, (state, action) => {
        state.summaryData = action.payload.Data;
      })
      .addCase(getDeployment.fulfilled, (state, action) => {
        state.deploymentData = action.payload.Data;
      })
      .addCase(getResignation.fulfilled, (state, action) => {
        state.ResignationGetData = action.payload.Data;
      })
      //CRM_ITEM_STOCK_GET

      .addCase(ItemstockAnalyticsGET.pending, (state, action) => {
        state.Itemstockstatus = "idle";
        state.itemstockDataAnalyticsLoading = true;
        // state.materialTrackingData = {
        //   Rateseries: {},
        //   Qtyseries: {},
        //   Amountseries: {},
        //   categories: [],
        //   TableData: { data: [] },
        // };
        state.itemstockDataAnalytics = []
      })

      .addCase(ItemstockAnalyticsGET.fulfilled, (state, action) => {
        state.Itemstockstatus = "success";
        state.itemstockDataAnalyticsLoading = false;
        state.itemstockDataAnalytics = action.payload.Data;
      })
      .addCase(ItemstockAnalyticsGET.rejected, (state, action) => {
        state.Itemstockstatus = "Error";
        state.itemstockDataAnalyticsLoading = false;
        state.itemstockDataAnalytics = [];
      })



      .addCase(procurementTrackingGet.pending, (state, action) => {
        state.Status = "idle";
        state.trackingLoading = true;
        state.materialTrackingData = {
          Rateseries: {},
          Qtyseries: {},
          Amountseries: {},
          categories: [],
          TableData: { data: [] },
        };
      })
      .addCase(procurementTrackingGet.fulfilled, (state, action) => {
        state.Status = "success";
        state.trackingLoading = false;
        state.materialTrackingData = action.payload.Data;
      })
      .addCase(procurementTrackingGet.rejected, (state, action) => {
        state.Status = "Error";
        state.trackingLoading = false;
        state.materialTrackingData = {};
      })
      //Employee Geo location get
      .addCase(geolocationData.fulfilled, (state, action) => {
        state.exploreData = action.payload.Data;
      })
      //Employee Geo location Update
      .addCase(geolocUpdate.pending, (state, action) => {
        state.Status = "idle";
        state.loading = true;
        state.Data = {};
      })
      .addCase(geolocUpdate.fulfilled, (state, action) => {
        state.Status = "success";
        state.loading = false;
        state.Data = action.payload.Data;
      })
      .addCase(geolocUpdate.rejected, (state, action) => {
        state.Status = "Error";
        state.loading = false;
        state.Data = {};
      })

      .addCase(materialDcTrckData.pending, (state, action) => {
        state.Status = "idle";
        state.trackingLoading = true;
        state.matrialDcTrackData = [];
      })
      .addCase(materialDcTrckData.fulfilled, (state, action) => {
        state.Status = "success";
        state.trackingLoading = false;
        state.matrialDcTrackData = action.payload.Data;
      })
      .addCase(materialDcTrckData.rejected, (state, action) => {
        state.Status = "Error";
        state.trackingLoading = false;
        state.matrialDcTrackData = [];
      })

      .addCase(searchData.pending, (state, action) => {
        state.Status = "idle";
        state.searchLoading = true;
      })
      .addCase(searchData.fulfilled, (state, action) => {
        state.Status = "success";
        state.searchLoading = false;
      })
      .addCase(searchData.rejected, (state, action) => {
        state.Status = "Error";
        state.searchLoading = false;
      })
      // .addCase(LeaderData.pending, (state, action) => {
      //   state.Status = "idle";
      //   state.searchLoading = true;
      // })
      // .addCase(LeaderData.fulfilled, (state, action) => {
      //   state.Status = "success";
      //   state.searchLoading = false;
      //    if (action.payload?.Status === "Y" && action.payload.Data?.length > 0) {
      //     state.leaderDetails = action.payload.Data[0];
      //   } else {
      //     state.leaderDetails = null;
      //   }
      // })
      // .addCase(LeaderData.rejected, (state, action) => {
      //   state.Status = "Error";
      //   state.searchLoading = false;
      // })
      .addCase(materialDcTrckChartData.fulfilled, (state, action) => {
        // state.Status = "success";
        // state.trackingLoading = false;
        state.stockReqData = action.payload.Data;
      })
      .addCase(stockorder.pending, (state, action) => {
        state.Status = "idle";
        state.trackingLoading = true;
        state.stockorderData = [];
      })

      .addCase(stockorder.fulfilled, (state, action) => {
        state.trackingLoading = false;
        state.stockorderData = action.payload.data;
      })
      //-----------------------------------------//
      .addCase(purchaseorderrating.pending, (state, action) => {
        state.Status = "idle";
        state.trackingLoading = true;
        state.purchaseorderratingData = [];
      })

      .addCase(purchaseorderrating.fulfilled, (state, action) => {
        state.trackingLoading = false;
        state.purchaseorderratingData = action.payload.Data;
      })
      .addCase(empAttendance.fulfilled, (state, action) => {
        state.empAttendanceData = action.payload.Data;
        state.empAttendanceDataLoading = false;
      })
      .addCase(empAttendance.pending, (state, action) => {
        state.Status = "idle";
        state.empAttendanceDataLoading = true;
        state.empAttendanceData = [];
      })
      .addCase(empAttendance.rejected, (state, action) => {
        state.Status = "Error";
        state.empAttendanceDataLoading = false;
        state.empAttendanceData = [];
      })



      .addCase(PayrollconfigpayrollAttendance.fulfilled, (state, action) => {
        state.PayrollconfigpayrollAttendanceData = action.payload.Data;
        state.PayrollconfigpayrollAttendanceLoading = false;
      })
      .addCase(PayrollconfigpayrollAttendance.pending, (state, action) => {
        state.Status = "idle";
        state.PayrollconfigpayrollAttendanceLoading = true;
        state.PayrollconfigpayrollAttendanceData = [];
      })
      .addCase(PayrollconfigpayrollAttendance.rejected, (state, action) => {
        state.Status = "Error";
        state.PayrollconfigpayrollAttendanceLoading = false;
        state.PayrollconfigpayrollAttendanceData = [];
      })
      // .addCase(Inventryget.fulfilled, (state, action) => {
      //   state.InventrygetData = action.payload.Data;
      //   state.InventrygetDataLoading = false;
      // })
      // .addCase(Inventryget.pending, (state, action) => {
      //   state.InventrygetDataStatus = "idle";
      //   state.InventrygetDataLoading = true;
      //   state.InventrygetData = [];
      // })
      // .addCase(Inventryget.rejected, (state, action) => {
      //   state.InventrygetDataStatus = "Error";
      //   state.InventrygetDataLoading = false;
      //   state.InventrygetData = [];
      // })
      .addCase(Inventryget.pending, (state) => {
        state.Inventoryloading = true;
      })

      .addCase(Inventryget.fulfilled, (state, action) => {
        state.Inventoryloading = false;

        if (action.payload?.Status === "Y") {
          state.InventrygetData = action.payload.Data || [];
        } else {
          state.InventrygetData = [];
        }
      })

      .addCase(Inventryget.rejected, (state) => {
        state.Inventoryloading = false;
        state.InventrygetData = [];
      })
      .addCase(payslipAttendance.fulfilled, (state, action) => {
        state.payslipAttendanceData = action.payload.Data;
        state.empAttendanceDataLoading = false;
      })
      .addCase(payslipAttendance.pending, (state, action) => {
        state.Status = "idle";
        state.empAttendanceDataLoading = true;
        state.payslipAttendanceData = [];
      })
      .addCase(payslipAttendance.rejected, (state, action) => {
        state.Status = "Error";
        state.empAttendanceDataLoading = false;
        state.payslipAttendanceData = [];
      })
      .addCase(Attendance.fulfilled, (state, action) => {
        state.AttendanceData = action.payload.Data;
        state.AttendanceDataLoading = false;
      })
      .addCase(Attendance.pending, (state, action) => {
        state.AttendanceDataStatus = "idle";
        state.AttendanceDataLoading = true;
      })
      .addCase(Attendance.rejected, (state, action) => {
        state.AttendanceData = {};
        state.AttendanceDataLoading = false;
      })
      .addCase(RegGetData.pending, (state, action) => {
        state.RegGetData = {};
        state.getLoading = true;
      })
      .addCase(RegGetData.fulfilled, (state, action) => {
        state.RegGetData = action.payload.Data;
        state.getLoading = false;
      })
      .addCase(RegGetData.rejected, (state, action) => {
        state.RegGetData = {};
        state.getLoading = false;
      })

      //SKILL-INSIGHTS
      .addCase(getInsights1.pending, (state) => {
        state.skillInsights2getdata = [];
        state.skillInsights1getdata = {};
        state.skillInsights1loading = true;
        state.error = null;
      })
      .addCase(getInsights1.fulfilled, (state, action) => {
        state.skillInsights2getdata = [];
        if (action.payload.Status === "Y") {
          // store full Data object
          state.skillInsights1getdata = action.payload.Data;
        } else {
          state.skillInsights1getdata = {};
        }
        state.skillInsights1loading = false;
        state.error = null;
      })
      .addCase(getInsights1.rejected, (state, action) => {
        state.skillInsights2getdata = [];
        state.skillInsights1getdata = {};
        state.skillInsights1loading = false;
        state.error = action.error.message;
      })

      .addCase(getInsights2.pending, (state) => {
        state.skillInsights2getdata = [];
        state.skillInsights2loading = true;
        state.error = null;
      })
      .addCase(getInsights2.fulfilled, (state, action) => {
        // if (action.payload.Status === "Y") {
        // store full Data object
        state.skillInsights2getdata = action.payload.Data;

        // } else {
        //   state.skillInsights2getdata = [];
        // }
        state.skillInsights2loading = false;
        state.error = null;
      })
      .addCase(getInsights2.rejected, (state, action) => {
        state.skillInsights2getdata = [];
        state.skillInsights2loading = false;
        state.error = action.error.message;
      })

      .addCase(scheduleGetData.pending, (state) => {
        state.schedulegetdata = [];
        state.scheduleloading = true;
        state.error = null;
      })
      .addCase(scheduleGetData.fulfilled, (state, action) => {
        state.schedulegetdata = action.payload.Data;

        state.scheduleloading = false;
        state.error = null;
      })
      .addCase(scheduleGetData.rejected, (state, action) => {
        state.schedulegetdata = [];
        state.scheduleloading = false;
        state.error = action.error.message;
      })

      //APPRAISAL BASED SCHEDULE
      .addCase(appraisalscheduleGetData.pending, (state) => {
        state.appraisalscheduleGetData = [];
        state.appraisalscheduleGetDataloading = true;
        state.error = null;
      })
      .addCase(appraisalscheduleGetData.fulfilled, (state, action) => {
        state.appraisalscheduleGetData = action.payload.Data;

        state.appraisalscheduleGetDataloading = false;
        state.error = null;
      })
      .addCase(appraisalscheduleGetData.rejected, (state, action) => {
        state.appraisalscheduleGetData = [];
        state.appraisalscheduleGetDataloading = false;
        state.error = action.error.message;
      })

      //VENDOR REGISTRATION GET
      .addCase(VendorRegisterFetchData.pending, (state) => {
        state.vendorregisterGetData = {};
        state.vendorregisterGetDataloading = true;
        state.error = null;
      })
      .addCase(VendorRegisterFetchData.fulfilled, (state, action) => {
        state.vendorregisterGetData = action.payload.Data;

        state.vendorregisterGetDataloading = false;
        state.error = null;
      })
      .addCase(VendorRegisterFetchData.rejected, (state, action) => {
        state.vendorregisterGetData = {};
        state.vendorregisterGetDataloading = false;
        state.error = action.error.message;
      })
      //ITEM FLAG GET
      .addCase(ItemFlagFetchData.pending, (state) => {
        state.itemFlagGetData = {};
        state.itemFlagGetDataloading = true;
        state.error = null;
      })
      .addCase(ItemFlagFetchData.fulfilled, (state, action) => {
        state.itemFlagGetData = action.payload.Data;

        state.itemFlagGetDataloading = false;
        state.error = null;
      })
      .addCase(ItemFlagFetchData.rejected, (state, action) => {
        state.itemFlagGetData = {};
        state.itemFlagGetDataloading = false;
        state.error = action.error.message;
      })
      //ITEM STOCK GET
      .addCase(ItemStockMenuGet.pending, (state) => {
        state.itemStockGetData = {};
        state.itemStockGetDataloading = true;
        state.error = null;
      })
      .addCase(ItemStockMenuGet.fulfilled, (state, action) => {
        state.itemStockGetData = action.payload.Data;

        state.itemStockGetDataloading = false;
        state.error = null;
      })
      .addCase(ItemStockMenuGet.rejected, (state, action) => {
        state.itemStockGetData = {};
        state.itemStockGetDataloading = false;
        state.error = action.error.message;
      })
      //ITEM MAIN GET BY ID
      .addCase(ItemMainGETFetchData.pending, (state) => {
        state.itemMainGETFetchData = {};
        state.itemMainGETFetchDataloading = true;
        state.error = null;
      })
      .addCase(ItemMainGETFetchData.fulfilled, (state, action) => {
        state.itemMainGETFetchData = action.payload.Data;

        state.itemMainGETFetchDataloading = false;
        state.error = null;
      })
      .addCase(ItemMainGETFetchData.rejected, (state, action) => {
        state.itemMainGETFetchData = {};
        state.itemMainGETFetchDataloading = false;
        state.error = action.error.message;
      })

      //VENDOR DEFAULT GET
      .addCase(VendorDefaultFetchData.pending, (state) => {
        state.vendorDefaultGetData = {};
        state.vendorDefaultGetDataloading = true;
        state.error = null;
      })
      .addCase(VendorDefaultFetchData.fulfilled, (state, action) => {
        state.vendorDefaultGetData = action.payload.Data;

        state.vendorDefaultGetDataloading = false;
        state.error = null;
      })
      .addCase(VendorDefaultFetchData.rejected, (state, action) => {
        state.vendorDefaultGetData = {};
        state.vendorDefaultGetDataloading = false;
        state.error = action.error.message;
      })
      //ITEM MAIN GET
      .addCase(ItemMainMenuFetchData.pending, (state) => {
        state.itemMainGetData = {};
        state.itemMainGetDataloading = true;
        state.error = null;
      })
      .addCase(ItemMainMenuFetchData.fulfilled, (state, action) => {
        state.itemMainGetData = action.payload;

        state.itemMainGetDataloading = false;
        state.error = null;
      })
      .addCase(ItemMainMenuFetchData.rejected, (state, action) => {
        state.itemMainGetData = {};
        state.itemMainGetDataloading = false;
        state.error = action.error.message;
      })
      // .addCase(TimeTableGenerateget.pending, (state) => {
      //   state.Status = "loading";
      //   state.loading = true;
      //   state.Data = {};
      //   state.AutogeneratecolumnData = [];
      //   state.AutogeneratecolumnData = [];
      // })

      // .addCase(TimeTableGenerateget.fulfilled, (state, action) => {
      //   state.Status = "success";
      //   state.loading = false;

      //   const data = action.payload.TimetableView;
      //   const breakSlots = action.payload.TimetableView?.BreakSlots;

      //   //  Save raw response
      //   state.Data = data;
      //   state.breakSlots = breakSlots; 
      //   //  Create dynamic columns
      //   state.AutogeneratecolumnData = [
      //     {
      //       field: "day",
      //       headerName: "Days",
      //       flex: 1,
      //       headerAlign: "center",
      //       align: "center",
      //     },
      //     ...data.timeSlots.map((slot) => ({
      //       field: slot,
      //       headerName: slot,
      //       flex: 1,
      //       headerAlign: "center",
      //       align: "center",
      //     })),
      //   ];

      //   //  Create dynamic rows
      //   state.AutogeneraterowData = data.schedule.map((item, index) => ({
      //     id: index + 1,
      //     day: item.day,
      //     ...item.slots,
      //   }));
      // })

      // .addCase(TimeTableGenerateget.rejected, (state) => {
      //   state.Status = "error";
      //   state.loading = false;
      // })
      .addCase(TimeTableGenerateget.pending, (state) => {
        state.Status = "loading";
        state.loading = true;
        // REMOVE: state.Data = {}; — don't clear Data on pending
        state.AutogeneratecolumnData = [];
        state.AutogeneraterowData = [];   //  fix typo: was AutogeneratecolumnData twice
      })

      .addCase(TimeTableGenerateget.fulfilled, (state, action) => {
        state.Status = "success";
        state.loading = false;

        const fullPayload = action.payload;
        const timetableView = fullPayload?.TimetableView;

        if (!timetableView) return; // guard if TimetableView missing

        //  Store the FULL response so calendarData?.TimetableView works in component
        state.Data = fullPayload;
        state.breakSlots = timetableView?.BreakSlots || [];

        //  Build columns: first col = Day, then one per timeSlot
        const timeSlots = timetableView.timeSlots || [];
        const schedule = timetableView.schedule || [];

        state.AutogeneratecolumnData = [
          {
            field: "day",
            headerName: "Days",
            width: 110,
            headerAlign: "center",
            align: "center",
          },
          ...timeSlots.map((slot, index) => ({
            field: `slot_${index}`,   //  safe field key (matches component logic)
            headerName: slot,
            width: 140,
            headerAlign: "center",
            align: "center",
          })),
        ];

        //  Build rows: one per day, slot_N as field keys
        state.AutogeneraterowData = schedule.map((item, index) => {
          const row = { id: index, day: item.day };
          timeSlots.forEach((slot, i) => {
            row[`slot_${i}`] = item.slots?.[slot] || "";
          });
          return row;
        });
      })

      .addCase(TimeTableGenerateget.rejected, (state) => {
        state.Status = "error";
        state.loading = false;
      })
      //LEADER GET
      .addCase(LeadEnquiryFilterGet.pending, (state) => {
        state.leaderEnquiryGetData = {};
        state.leaderEnquiryGetDataloading = true;
        state.error = null;
      })
      .addCase(LeadEnquiryFilterGet.fulfilled, (state, action) => {
        // state.leaderEnquiryGetData = action.payload;
        state.leaderEnquiryGetData = action.payload.Data || {};
        state.leaderEnquiryGetDataloading = false;
        state.error = null;
      })
      .addCase(LeadEnquiryFilterGet.rejected, (state, action) => {
        state.leaderEnquiryGetData = {};
        state.leaderEnquiryGetDataloading = false;
        state.error = action.error.message;
      })
      //DefaultProductDeliveryChargeGet
      .addCase(DefaultProductDeliveryChargeGet.pending, (state) => {
        state.DefaultProductDeliveryChargeGetData = {};
        state.DefaultProductDeliveryChargeGetDataloading = true;
        state.error = null;
      })
      .addCase(DefaultProductDeliveryChargeGet.fulfilled, (state, action) => {
        state.DefaultProductDeliveryChargeGetData = action.payload.Data;

        state.DefaultProductDeliveryChargeGetDataloading = false;
        state.error = null;
      })
      .addCase(DefaultProductDeliveryChargeGet.rejected, (state, action) => {
        state.DefaultProductDeliveryChargeGetData = {};
        state.DefaultProductDeliveryChargeGetDataloading = false;
        state.error = action.error.message;
      })
      //PROJECT COSTING PDF
      .addCase(getProjectCosting.pending, (state) => {
        state.projectCostinggetdata = {};
        state.projectCostingloading = true;
        state.error = null;
      })
      .addCase(getProjectCosting.fulfilled, (state, action) => {
        state.projectCostinggetdata = action.payload.Data;
        state.projectCostingloading = false;
        state.error = null;
      })
      .addCase(getProjectCosting.rejected, (state, action) => {
        state.projectCostinggetdata = {};
        state.projectCostingloading = false;
        state.error = action.error.message;
      })

      //ORDER HEADER PDF
      .addCase(getOrderdetailReport.pending, (state) => {
        state.OrderdetailReportgetdata = {};
        state.OrderdetailReportloading = true;
        state.error = null;
      })
      .addCase(getOrderdetailReport.fulfilled, (state, action) => {
        state.OrderdetailReportgetdata = action.payload.Data;
        state.OrderdetailReportloading = false;
        state.error = null;
      })
      .addCase(getOrderdetailReport.rejected, (state, action) => {
        state.OrderdetailReportgetdata = {};
        state.OrderdetailReportloading = false;
        state.error = action.error.message;
      })

      //Audit UserGETController

      .addCase(auditUserActivityGET.pending, (state) => {
        state.Auditgetstatus = "loading";
        state.Auditgetloading = true;
        state.Auditgetdata = [];
      })
      .addCase(auditUserActivityGET.fulfilled, (state, action) => {
        state.Auditgetstatus = "succeeded";
        state.Auditgetloading = false;
        state.Auditgetdata = action.payload.Data;
      })
      .addCase(auditUserActivityGET.rejected, (state, action) => {
        state.Auditgetstatus = "failed";
        state.Auditgetloading = false;
        state.error = action.error.message;
        state.Auditgetdata = [];
      })

      //AuditScrenCompanyGET

      .addCase(auditScreennameGET.pending, (state) => {
        state.Auditcompanygetstatus = "loading";
        state.Auditcompanygetloading = true;
        state.AuditScreennamegetdata = [];
      })
      .addCase(auditScreennameGET.fulfilled, (state, action) => {
        state.Auditcompanygetstatus = "succeeded";
        state.Auditcompanygetloading = false;
        state.AuditScreennamegetdata = action.payload.Data;
      })
      .addCase(auditScreennameGET.rejected, (state, action) => {
        state.Auditcompanygetstatus = "failed";
        state.Auditcompanygetloading = false;
        state.error = action.error.message;
        state.AuditScreennamegetdata = [];
      })

      .addCase(getLeaveweeklyData.pending, (state) => {
        state.Status = "idle";
        state.getLoading = true;
        state.leaveweeklyData = {
          Employee: "",
          Year: "",
          LeaveDetailsData: {
            TableData: [],
            Others: [],
          },
        };
        state.msg = "Loading...";
      })

      .addCase(getLeaveweeklyData.rejected, (state) => {
        state.Status = "Error";
        state.getLoading = false;
        state.leaveweeklyData = {
          Employee: "",
          Year: "",
          LeaveDetailsData: {
            TableData: [],
            Others: [],
          },
        };
        toast.error("Something Went Wrong");
      })

      // .addCase(getLeaveweeklyData.fulfilled, (state, action) => {
      //   state.Status = "success";
      //   state.getLoading = false;
      //   state.leaveweeklyData = action.payload.Data ? action.payload.Data : {};
      //   // state.msg =  action.payload.Msg
      // })
      .addCase(getLeaveweeklyData.fulfilled, (state, action) => {
        state.Status = "success";
        state.getLoading = false;
        state.leaveweeklyData = action.payload?.Data?.[0] || {
          Employee: "",
          Year: "",
          LeaveDetailsData: {
            TableData: [],
            Others: [],
          },
        };
      })
      //SOP Process POST
      .addCase(SOPProcessPost.pending, (state, action) => {
        state.SOPProcessStatus = "idle";
        state.SOPProcessLoading = true;
      })
      .addCase(SOPProcessPost.fulfilled, (state, action) => {
        state.SOPProcessStatus = "success";
        state.SOPProcessLoading = false
        state.SOPProcessdata = action.meta.arg.idata;
      })

      .addCase(SOPProcessPost.rejected, (state, action) => {
        state.SOPProcessStatus = "Error";
        state.SOPProcessLoading = false;
      })
      //SOP CONFIG POST
      .addCase(SOPConfigPost.pending, (state, action) => {
        state.SOPConfigStatus = "idle";
        state.SOPConfigLoading = true;
      })
      .addCase(SOPConfigPost.fulfilled, (state, action) => {
        state.SOPConfigStatus = "success";
        state.SOPConfigLoading = false
        state.SOPConfigdata = action.meta.arg.idata;
      })

      .addCase(SOPConfigPost.rejected, (state, action) => {
        state.SOPConfigStatus = "Error";
        state.SOPConfigLoading = false;
      })

      //SOP CONFIGURATION  - GET
      .addCase(SOPConfigGet.pending, (state, action) => {
        state.SOPConfigGetstatus = "idle";
        state.SOPConfigGetloading = true;
      })
      .addCase(SOPConfigGet.fulfilled, (state, action) => {
        state.SOPConfigGetstatus = "success";
        state.SOPConfigGetloading = false;
        state.SOPConfigGetdata = action.payload.Data
          ? action.payload.Data
          : {};
      })
      .addCase(SOPConfigGet.rejected, (state, action) => {
        state.SOPConfigGetstatus = "Error";
        state.SOPConfigGetloading = false;
      })
      //SPECIMEN - GET
      .addCase(SpecimenGet.pending, (state, action) => {
        state.SpecimenGetstatus = "idle";
        state.SpecimenGetloading = true;
      })
      .addCase(SpecimenGet.fulfilled, (state, action) => {
        state.SpecimenGetstatus = "success";
        state.SpecimenGetloading = false;
        state.SpecimenGetdata = action.payload.Data
          ? action.payload.Data
          : {};
      })
      .addCase(SpecimenGet.rejected, (state, action) => {
        state.SpecimenGetstatus = "Error";
        state.SpecimenGetloading = false;
      })
      //SPECIMEN - POST
      .addCase(SpecimenPost.pending, (state, action) => {
        state.SpecimenPoststatus = "idle";
        state.SpecimenPostloading = true;
      })
      .addCase(SpecimenPost.fulfilled, (state, action) => {
        state.SpecimenPoststatus = "success";
        state.SpecimenPostloading = false;
        state.SpecimenPostdata = action.payload.Data
          ? action.payload.Data
          : {};
      })
      .addCase(SpecimenPost.rejected, (state, action) => {
        state.SpecimenPoststatus = "Error";
        state.SpecimenPostloading = false;
      })
      //SopEmpMappingController - POST
      .addCase(SopEmpMappingController.pending, (state, action) => {
        state.SopEmpMappingControllerstatus = "idle";
        state.SopEmpMappingControllerloading = true;
      })
      .addCase(SopEmpMappingController.fulfilled, (state, action) => {
        state.SopEmpMappingControllerstatus = "success";
        state.SopEmpMappingControllerloading = false;
        state.SopEmpMappingControllerdata = action.payload.Data
          ? action.payload.Data
          : {};
      })
      .addCase(SopEmpMappingController.rejected, (state, action) => {
        state.SopEmpMappingControllerstatus = "Error";
        state.SopEmpMappingControllerloading = false;
      })
      //PARTY ORDER PENDING - GET
      .addCase(PartyOrderPendingGet.pending, (state, action) => {
        state.PartyOrderPendingGetstatus = "idle";
        state.PartyOrderPendingGetloading = true;
      })
      .addCase(PartyOrderPendingGet.fulfilled, (state, action) => {
        state.PartyOrderPendingGetstatus = "success";
        state.PartyOrderPendingGetloading = false;
        state.PartyOrderPendingGetdata = action.payload.Data
          ? action.payload.Data
          : {};
      })
      .addCase(PartyOrderPendingGet.rejected, (state, action) => {
        state.PartyOrderPendingGetstatus = "Error";
        state.PartyOrderPendingGetloading = false;
      })

      //SOP TIMELINE - GET
      .addCase(SopTimeLineController.pending, (state, action) => {
        state.SOPTimelinestatus = "idle";
        state.SOPTimelineloading = true;
      })
      .addCase(SopTimeLineController.fulfilled, (state, action) => {
        state.SOPTimelinestatus = "success";
        state.SOPTimelineloading = false;
        state.SOPTimelinedata = action.payload.Data
          ? action.payload.Data
          : {};
      })
      .addCase(SopTimeLineController.rejected, (state, action) => {
        state.SOPTimelinestatus = "Error";
        state.SOPTimelineloading = false;
      })
      //GetOverflowAffectedOrders - GET
      .addCase(GetOverflowAffectedOrders.pending, (state, action) => {
        state.GetOverflowAffectedOrdersstatus = "idle";
        state.GetOverflowAffectedOrdersloading = true;
      })
      .addCase(GetOverflowAffectedOrders.fulfilled, (state, action) => {
        state.GetOverflowAffectedOrdersstatus = "success";
        state.GetOverflowAffectedOrdersloading = false;
        state.GetOverflowAffectedOrdersdata = action.payload
          ? action.payload
          : {};
      })
      .addCase(GetOverflowAffectedOrders.rejected, (state, action) => {
        state.GetOverflowAffectedOrdersstatus = "Error";
        state.GetOverflowAffectedOrdersloading = false;
      })
      //PartyReset - GET
      .addCase(PartyReset.pending, (state, action) => {
        state.PartyResetstatus = "idle";
        state.PartyResetloading = true;
      })
      .addCase(PartyReset.fulfilled, (state, action) => {
        state.PartyResetstatus = "success";
        state.PartyResetloading = false;
        state.PartyResetdata = action.payload
          ? action.payload
          : {};
      })
      .addCase(PartyReset.rejected, (state, action) => {
        state.PartyResetstatus = "Error";
        state.PartyResetloading = false;
      })
      .addCase(TimetableProcessController.pending, (state, action) => {
        state.Timetableresetstatus = "idle";
        state.Timetableresetloading = true;
      })
      .addCase(TimetableProcessController.fulfilled, (state, action) => {
        state.Timetableresetstatus = "success";
        state.Timetableresetloading = false;
        state.Timetableresetdata = action.payload
          ? action.payload
          : {};
      })
      .addCase(TimetableProcessController.rejected, (state, action) => {
        state.Timetableresetstatus = "Error";
        state.Timetableresetloading = false;
      })
      .addCase(PublishEvent.pending, (state, action) => {
        state.PublishEventstatus = "idle";
        state.PublishEventloading = true;
      })
      .addCase(PublishEvent.fulfilled, (state, action) => {
        state.PublishEventstatus = "success";
        state.PublishEventloading = false;
        state.PublishEventdata = action.payload
          ? action.payload
          : {};
      })
      .addCase(PublishEvent.rejected, (state, action) => {
        state.PublishEventstatus = "Error";
        state.PublishEventloading = false;
      })
      //PartyAnalytics - GET
      .addCase(PartyAnalytics.pending, (state, action) => {
        state.PartyAnalyticsstatus = "idle";
        state.PartyAnalyticsloading = true;
      })
      .addCase(PartyAnalytics.fulfilled, (state, action) => {
        state.PartyAnalyticsstatus = "success";
        state.PartyAnalyticsloading = false;
        state.PartyAnalyticsdata = action.payload
          ? action.payload
          : {};
      })
      .addCase(PartyAnalytics.rejected, (state, action) => {
        state.PartyAnalyticsstatus = "Error";
        state.PartyAnalyticsloading = false;
      })

      .addCase(ContractInvoice.pending, (state, action) => {
        state.InvoiceHeaderDatastatus = "idle";
        state.InvoiceHeaderDataloading = true;
      })
      .addCase(ContractInvoice.fulfilled, (state, action) => {
        state.InvoiceHeaderData =
          action.payload.HeaderData ? action.payload.HeaderData : [];
        state.InvoiceDetailData =
          action.payload.DetailData ? action.payload.DetailData : [];
        state.InvoiceBaseUrl =
          action.payload.BaseUrl ? action.payload.BaseUrl : [];
      })
      .addCase(ContractInvoice.rejected, (state, action) => {
        state.InvoiceHeaderDatastatus = "Error";
        state.InvoiceHeaderDataloading = false;
      })
      //SCOREBOARD
      // .addCase(ScoredashBoard.pending, (state, action) => {
      //   // state.ScoredashBoardGetData = []
      //   state.ScoredashBoardGetStaus = "pending";
      //   state.ScoredashBoardGetLoading = true;
      //   state.ScoredashBoardGetError = null;
      // })

      // .addCase(ScoredashBoard.fulfilled, (state, action) => {
      //   state.ScoredashBoardGetData = action.payload;
      //   state.ScoredashBoardGetStaus = "fulfilled";
      //   state.ScoredashBoardGetLoading = false;
      //   state.ScoredashBoardGetError = null;
      //   console.log("ScoredashBoardGetData",state.ScoredashBoardGetData)
      // })
      // .addCase(ScoredashBoard.rejected, (state, action) => {
      //   // state.ScoredashBoardGetData = [];
      //   state.ScoredashBoardGetStaus = "rejected";
      //   state.ScoredashBoardGetLoading = false;
      //   state.ScoredashBoardGetError = null;
      // })


      .addCase(timeSheet.fulfilled, (state, action) => {
        state.timeSheetData = action.payload?.Data?.Task || [];
        state.projectName =
          action.payload?.Data?.ProjectName?.ProjectName || "";
        state.managerName =
          action.payload?.Data?.ManagersName?.ManagersName || "";
      })
      .addCase(MonthlyAttendance.pending, (state, action) => {
        state.MonthlyAttendanceDataGetloading = true;
      })
      .addCase(MonthlyAttendance.fulfilled, (state, action) => {
        state.MonthlyAttendanceDataGetloading = false;
        state.MonthlyAttendanceData = action.payload.Data;
      });
  },
});

// Destructure and export the plain action creators
export const {
  pending,
  errored,
  resetregularizedata,
  userGroupUpdate,
  Success,
  stockSuccess,
  stockReqSuccess,
  resetTrackingData,
  resetPartyAnalyticsdata,
  resetTimeSheetAttendance,
  // packingListCarton
  clearData,
  ratingChange,
} = getApiSlice.actions;

export default getApiSlice.reducer;

export const fetchApidata =
  (AccessID, Action, idata) => (dispatch, getState) => {
    //  alert(Action);

    var url = store.getState().globalurl.apiUrl;
    var data = {
      accessid: AccessID,
      action: Action,
      recid: idata,
    };

    console.log(
      "🚀 ~ file: Formapireducer.js:794 ~ JSON.stringify(data):",
      JSON.stringify(data),
    );
    dispatch(pending());
    axios
      .post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      })

      .then((response) => {
        console.log(
          "🚀 ~ file: Formapireducer.js:413 ~ .then ~ response:",
          response,
        );
        console.log("response data" + JSON.stringify(response.data));
        var apidata = response.data;
        // console.log("🚀 ~ file: Formapireducer.js:415 ~ .then ~ response.data:", response.data)

        //     apidata=eval(apidata);
        //    console.log("apidatastatus"+typeof(response.data))
        if (apidata.Status == "Y") {
          // console.log("apidata" + JSON.stringify(apidata.Data));

          if (apidata.Data.Disable == "Y") {
            apidata.Data.Disable = true;
          } else apidata.Data.Disable = false;
          if (AccessID == "TR014") {
            if (apidata.Data.Process == "Y") {
              apidata.Data.Process = true;
            } else apidata.Data.Process = false;
          }
          if (AccessID == "TR014") {
            if (apidata.Data.Regularslno == "Y") {
              apidata.Data.Regularslno = true;
            } else apidata.Data.Regularslno = false;
          }
          if (AccessID == "TR003") {
            if (apidata.Data.Hidevisible == "Y") {
              apidata.Data.Hidevisible = true;
            } else apidata.Data.Hidevisible = false;
          }
          if (AccessID == "TR004") {
            if (apidata.Data.Rawmaterial == "Y") {
              apidata.Data.Rawmaterial = true;
            } else apidata.Data.Rawmaterial = false;

            if (apidata.Data.Consumable == "Y") {
              apidata.Data.Consumable = true;
            } else apidata.Data.Consumable = false;

            if (apidata.Data.Sellable == "Y") {
              apidata.Data.Sellable = true;
            } else apidata.Data.Sellable = false;
            if (apidata.Data.DesignApp == "Y") {
              apidata.Data.DesignApp = true;
            } else apidata.Data.DesignApp = false;
          }

          if (AccessID == "TR010") {
            if (apidata.Data.ForiegnAgentFlag == "Y") {
              apidata.Data.ForiegnAgentFlag = true;
            } else apidata.Data.ForiegnAgentFlag = false;

            if (apidata.Data.LocalAgentFlag == "Y") {
              apidata.Data.LocalAgentFlag = true;
            } else apidata.Data.LocalAgentFlag = false;
          }
          if (AccessID == "TR021") {
            if (apidata.Data.Duration == "Y") {
              apidata.Data.Duration = true;
            } else apidata.Data.Duration = false;

            if (apidata.Data.Incharge == "Y") {
              apidata.Data.Incharge = true;
            } else apidata.Data.Incharge = false;
          }
          if (AccessID == "TR009") {
            if (apidata.Data.Jobwork == "Y") {
              apidata.Data.Jobwork = true;
            } else apidata.Data.Jobwork = false;
          }
          if (AccessID == "TR110") {
            if (apidata.Data.Sameplist == "Y") {
              apidata.Data.Sameplist = true;
            } else apidata.Data.Sameplist = false;
          }
          if (AccessID == "TR085") {
            if (apidata.Data.Productcost == "Y") {
              apidata.Data.Productcost = true;
            } else apidata.Data.Productcost = false;
          }
          dispatch(
            Success({
              action: Action,
              Status: apidata.Status,
              apiResponse: apidata.Data,
              Msg: "",

              accessID: AccessID,
            }),
          );
        } else {
          dispatch(
            Success({
              action: Action,
              Status: apidata.Status,

              accessID: AccessID,
            }),
          );
        }
      })
      .catch((error) => {
        dispatch(errored);
        //dispatch(errored({"action":Action,"Status":apidata.Status,"apiResponse":apidata.Data,"Msg":""}))
      });
  };

export function postApidata(AccessID, Action, idata) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + success.data.Status);

      const datawait = dispatch(
        Success({
          action: Action,
          Status: success.data.Status,
          // data:success.
          apiResponse: {},
          Msg: success.data.Msg,
        }),
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      console.log("---", idata);
      var isCompanyID = Object.hasOwn(idata, "CompanyID");
      var isFinyear = Object.hasOwn(idata, "Finyear");
      const Finyear = sessionStorage.getItem("YearRecorid");
      const CompanyID = sessionStorage.getItem("compID");
      if (!isCompanyID && AccessID !== "TR030" && AccessID !== "TR076") {
        idata = {
          ...idata,
          CompanyID,
        };
      }
      if (!isFinyear && AccessID !== "TR030" && AccessID !== "TR076") {
        idata = {
          ...idata,
          Finyear,
        };
      }
      console.log("🚀 ~ file: Formapireducer.js:734 ~ return ~ idata:", idata);
      var url = store.getState().globalurl.apiUrl;
      var data = {
        accessid: AccessID,
        action: Action,
        data: idata,
      };
      dispatch(pending());
      console.log("postdata" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      console.log(
        "🚀 ~ file: Formapireducer.js:335 ~ return ~ success:",
        success,
      );
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function proformainvApidata(
  RecordID,
  ProfoInvoiceNO,
  ProfoInvoiceDate,
  parentID,
  YearID,
) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + success.data.Status);

      const datawait = dispatch(
        Success({
          action: "",
          Status: success.data.Status,
          apiResponse: {},
          Msg: success.data.Msg,
        }),
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.proformainvUrl;
      const Finyear = sessionStorage.getItem("YearRecorid");
      const CompanyID = sessionStorage.getItem("compID");
      var data = {
        RecordID: RecordID,
        ProfoInvoiceNO: ProfoInvoiceNO,
        ProfoInvoiceDate: ProfoInvoiceDate,
        type: parentID,
        YearID: YearID,
        CompanyID,
        Finyear,
      };
      dispatch(pending());
      console.log("postdata" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function finalinvApidata(
  RecordID,
  FinalInvoiceNO,
  FinalInvoiceDate,
  parentID,
  YearID,
) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + success.data.Status);

      const datawait = dispatch(
        Success({
          action: "",
          Status: success.data.Status,
          apiResponse: {},
          Msg: success.data.Msg,
        }),
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      const Finyear = sessionStorage.getItem("YearRecorid");
      const CompanyID = sessionStorage.getItem("compID");
      var url = store.getState().globalurl.finalinvUrl;
      var data = {
        RecordID: RecordID,
        FinalInvoiceNO: FinalInvoiceNO,
        FinalInvoiceDate: FinalInvoiceDate,
        type: parentID,
        YearID: YearID,
        CompanyID,
        Finyear,
      };
      dispatch(pending());
      console.log("postdata" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function postApidatawol(AccessID, Action, idata) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + success.data.Status);

      const datawait = dispatch(
        Success({
          action: Action,
          Status: success.data.Status,
          apiResponse: success.data.Recid,
          Msg: success.data.Msg,
          // Data: idata
        }),
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.apiUrl;
      var data = {
        accessid: AccessID,
        action: Action,
        data: idata,
      };
      dispatch(pending());
      console.log("postdata" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      console.log(
        "🚀 ~ file: Formapireducer.js:475 ~ return ~ success:",
        success,
      );
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function fetchRecIDApidata(AccessID, Action, idata) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + success.data.Status);
      const datawait = dispatch(
        Success({
          action: Action,
          Status: success.data.Status,
          apiResponse: success.data.Data,
          Msg: "",
        }),
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.apiUrl;
      var data = {
        accessid: AccessID,
        action: Action,
        recid: idata,
      };
      dispatch(pending());
      console.log("get" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      // console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function VersioningFetch(recid) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + success.data.Status);
      const datawait = dispatch(
        Success({
          action: "get",
          Status: success.data.Status,
          apiResponse: success.data.Data,
          Msg: "",
        }),
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.commonUrl;
      var data = {
        recid: recid,
        action: "get",
        accessid: "",
      };

      dispatch(pending());
      console.log("get" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      // console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}
// supplier Tracking
export function supplierTrackFetch(SupplierID) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + JSON.stringify(success));
      console.log("2---" + JSON.stringify(success.data.Data));
      const datawait = dispatch(
        Success({
          action: "get",
          Status: success.data.Status,
          apiResponse: success.data.Data,
          Msg: "",
        }),
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.supplierTrackUrl;
      var data = { SupplierID: SupplierID };

      dispatch(pending());
      console.log("get" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function TrackingFetchfn(MaterialID, Type) {
  return async (dispatch) => {
    function onSuccess(success) {
      // console.log("2---" +JSON.stringify(success));
      //  console.log("2---" + JSON.stringify(success.data));
      const datawait = dispatch(
        Success({
          // action: "get",
          // Status: success.data.Status,
          apiResponse: success.data,
          // Msg: "",
        }),
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.trackingUrl;
      var data = {
        MaterialID: MaterialID,
        Type: Type,
      };

      dispatch(pending());
      console.log("get" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function bomCopyApiData(recid, type) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + success.data.Status);
      const datawait = dispatch(
        Success({
          action: "get",
          Status: success.data.Status,
          apiResponse: {},
          Msg: "",
        }),
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.bomCopyUrl;
      var data = {
        BhprdRecordID: recid,
      };

      dispatch(pending());
      console.log("get" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      // console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function bomFetchapiData(AccessID, Action, idata) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + success.data.Status);
      const datawait = dispatch(
        Success({
          action: Action,
          Status: success.data.Status,
          apiResponse: success.data.Data,
          Msg: "",
        }),
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.bomHeaderUrl;

      var data = {
        recid: AccessID,
        action: Action,
        ProductID: idata,
      };
      dispatch(pending());
      console.log("get" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      // console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function stockFetchapiData(AccessID, Action, idata) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + success.data.Status);
      const datawait = dispatch(
        Success({
          action: Action,
          Status: success.data.Status,
          apiResponse: success.data.Data,
          Msg: "",
        }),
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.apiUrl;

      var data = {
        accessid: AccessID,
        action: Action,
        recid: idata,
      };
      dispatch(pending());
      console.log("get" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export const stockApidata =
  (AccessID, recid, Type, Year) => (dispatch, getState) => {
    //  alert(Action);

    var url = store.getState().globalurl.stockUrl;
    var data = {
      Query: {
        accessid: AccessID,
        recid: recid,
        Type: Type,
        Year: Year,
      },
    };
    data = JSON.stringify(data);
    console.log(data);
    dispatch(pending());
    axios
      .get(url, {
        params: {
          data: data,
        },

        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      })

      .then((response) => {
        console.log("response data" + JSON.stringify(response.data));
        var apidata = response.data;

        //     apidata=eval(apidata);
        //    console.log("apidatastatus"+typeof(response.data))
        if (apidata.Status == "Y") {
          console.log("apidata" + JSON.stringify(apidata.Data));

          dispatch(
            Success({
              action: "get",
              Status: apidata.Status,
              apiResponse: apidata.Data,
              Msg: "",
            }),
          );
        } else {
          dispatch(
            Success({
              action: "get",
              Status: apidata.Status,
              apiResponse: apidata.Data,
              Msg: "",
            }),
          );
        }
      })
      .catch((error) => {
        dispatch(errored);
        //dispatch(errored({"action":Action,"Status":apidata.Status,"apiResponse":apidata.Data,"Msg":""}))
      });
  };

export const batchApidata =
  (productID, ProformaID, bomID) => (dispatch, getState) => {
    var url = store.getState().globalurl.batchUrl;
    var data = {
      Query: {
        ProfomID: ProformaID,
        ProductID: productID,
        BomHeader: bomID,
      },
    };
    data = JSON.stringify(data);
    console.log(data);
    dispatch(pending());
    axios
      .get(url, {
        params: {
          data: data,
        },

        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      })

      .then((response) => {
        console.log("response data" + JSON.stringify(response.data));
        var apidata = response.data;

        //     apidata=eval(apidata);
        //    console.log("apidatastatus"+typeof(response.data))
        if (apidata.Status == "Y") {
          console.log("apidata" + JSON.stringify(apidata.Data));

          dispatch(
            Success({
              action: "get",
              Status: apidata.Status,
              apiResponse: apidata.Data,
              Msg: "",
            }),
          );
        } else {
          dispatch(
            Success({
              action: "get",
              Status: apidata.Status,
              apiResponse: apidata.Data,
              Msg: "",
            }),
          );
        }
      })
      .catch((error) => {
        dispatch(errored);
        //dispatch(errored({"action":Action,"Status":apidata.Status,"apiResponse":apidata.Data,"Msg":""}))
      });
  };

export function orderFetchapiData(name) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("Inside Stock-" + success.data.Status);
      const datawait = dispatch(
        Success({
          Status: success.data.Status,
          apiResponse: success.data.Data,
        }),
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.orderUrl;

      var data = {
        Query: {
          Name: name,
        },
      };
      data = JSON.stringify(data);
      console.log("---" + url);
      dispatch(pending());

      const success = await axios.get(url, {
        params: {
          data: data,
        },
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      // console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function stockvalueFetchapiData(name) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("Inside Stock-" + success.data.Status);
      const datawait = dispatch(
        stockSuccess({
          stockapiResponse: success.data.Data,
        }),
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.productUrl;

      var data = {
        Query: {
          Name: name,
        },
      };
      data = JSON.stringify(data);
      console.log("---" + url);
      dispatch(pending());

      const success = await axios.get(url, {
        params: {
          data: data,
        },
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      // console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function MaterialTrackingFetchData(RecordID, Type) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("chartData---" + JSON.stringify(success));
      const datawait = dispatch(
        stockReqSuccess({
          stockReqapiResponse: success.data.Data,
        }),
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.materialsTrackingUrl;

      var data = {
        Query: {
          RecordID: RecordID,
          Type: Type,
        },
      };
      data = JSON.stringify(data);
      console.log("---" + data);
      dispatch(pending());

      const success = await axios.get(url, {
        params: {
          data: data,
        },
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("chart Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function supplierTrackingFetchData(RecordID) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("Inside Stock-" + JSON.stringify(success));
      const datawait = dispatch(
        stockReqSuccess({
          stockReqapiResponse: success.data.Data,
        }),
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.supplytrackingUrl;

      var data = {
        Query: {
          RecordID: RecordID,
        },
      };
      data = JSON.stringify(data);
      // console.log("---"+url);
      dispatch(pending());

      const success = await axios.get(url, {
        params: {
          data: data,
        },
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function stockRequirementFetchapiData(name) {
  return async (dispatch) => {
    function onSuccess(success) {
      // console.log("Inside Stock-" + success.data.Status);
      const datawait = dispatch(
        stockReqSuccess({
          stockReqapiResponse: success.data.Data,
        }),
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.stockReqUrl;

      var data = {
        Query: {
          Name: name,
        },
      };
      data = JSON.stringify(data);
      console.log("🚀 ~ file: Formapireducer.js:1353 ~ return ~ data:", data);
      // console.log("---"+url);
      dispatch(pending());

      const success = await axios.get(url, {
        params: {
          data: data,
        },
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      // console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}
export const timeSheetPostData = createAsyncThunk(
  "timeSheetPostData/post",
  async ({ idata }) => {
    var url = store.getState().globalurl.timesheetdtUrl;
    const response = await axios.post(url, idata, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const empAttendance = createAsyncThunk(
  "employee/Payrollattendance",
  async ({ data }) => {
    var url = store.getState().globalurl.payrollattendanceUrl;

    // var url = store.getState().globalurl.employeeattendanceUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

export const PayrollconfigpayrollAttendance = createAsyncThunk(
  "Payroll Configuation/Payrollattendance",
  async ({ data }) => {
    var url = store.getState().globalurl.GetPayrollattendaceUrl;
    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const Inventryget = createAsyncThunk(
  "Inventryget/Inventorygetitem",
  async ({ data }) => {
    var url = store.getState().globalurl.EmpInventoryGetController;
    // var url = store.getState().globalurl.employeeattendanceUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const payslipAttendance = createAsyncThunk(
  "employee/Payslipattendance",
  async ({ data }) => {
    var url = store.getState().globalurl.payslipattendanceUrl;
    // var url = store.getState().globalurl.employeeattendanceUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const ItempriceGet = createAsyncThunk(
  "employee/ItempriceGet",
  async (data) => {
    var url = store.getState().globalurl.ItempriceGeturl;
    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const MonthlyAttendance = createAsyncThunk(
  "employee/monthlyattendance",
  async ({ data }) => {
    var url = store.getState().globalurl.monthlyattendanceUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const timeSheet = createAsyncThunk(
  "timeSheet/timeSheetattendance",
  async ({ data }) => {
    var url = store.getState().globalurl.timesheetattendanceUrl;
    // var url = store.getState().globalurl.employeeattendanceUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const timeSheetreport = createAsyncThunk(
  "timeSheet/timeSheetattendance",
  async ({ data }) => {
    var url = store.getState().globalurl.timesheetreportattendanceUrl;
    // var url = store.getState().globalurl.employeeattendanceUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

// export const leaveenquiryget = createAsyncThunk(
//   "leavenquiry/leaveenquiryget",
//   async (data, { rejectWithValue }) => {
//     try {
//       const url = store.getState().globalurl.LeaveenquiryGetController;

//       console.log("Request Data:", data);
// const data = {
//       data:data
//     };
//       const response = await axios.post(url, data, {
//         headers: {
//           Authorization:
//             "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
//         },
//       });

//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );
export const leaveenquiryget = createAsyncThunk(
  "leavenquiry/leaveenquiryget",
  async (payload, { rejectWithValue }) => {
    try {
      const url = store.getState().globalurl.LeaveenquiryGetController;

      // 👇 Wrap exactly as backend expects
      const requestBody = {
        FromDate: payload.FromDate,
        ToDate: payload.ToDate,
        LeaveTypeID: payload.LeaveTypeID,
        EmployeesID: payload.EmployeesID,
        CompanyID: payload.CompanyID,
        Permission: payload.Permission,
      };

      console.log("Final Request Body:", JSON.stringify(requestBody));

      const response = await axios.post(url, requestBody, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Leave enquiry API error:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const EmployeeVendorGetController = createAsyncThunk(
  "empvendorget/empvendorgetfile",
  async (payload, { rejectWithValue }) => {
    try {
      const url = store.getState().globalurl.EmployeeVendorGetController;

      const requestBody = {
        EmployeeID: payload.EmployeeID,
        CompanyID: payload.CompanyID,
        action: payload.action,
      };

      console.log("Final Request Body:", JSON.stringify(requestBody));

      const response = await axios.post(url, requestBody, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Leave enquiry API error:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const EmployeeVendorContactGet = createAsyncThunk(
  "empvendorcontactget/empvendorcontactgetfile",
  async (payload, { rejectWithValue }) => {
    try {
      const url = store.getState().globalurl.EmployeeVendorContactGet;

      const requestBody = {
        EmployeeID: payload.EmployeeID,
        VendorID: payload.VendorID,
        CompanyID: payload.CompanyID,
        action: payload.action,
      };

      console.log("Final Request Body:", JSON.stringify(requestBody));

      const response = await axios.post(url, requestBody, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Leave enquiry API error:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const userActivityLog = createAsyncThunk(
  "activity/log",
  async ({ RecordID, UserID, CompanyID, AccessID, Activity, Type }) => {
    const url = store.getState().globalurl.UserActivityUrl;
    // OR hardcode:
    // const url = "https://essuat.beyondexs.com/api/UserActivityController.php";

    const payload = {
      RecordID,
      UserID,
      CompanyID,
      AccessID,
      Activity,
      Type,
    };

    const response = await axios.post(url, payload, {
      headers: {
        Authorization: "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ...",
      },
    });

    return response.data;
  },
);

export const OHPaymentUpdateController = createAsyncThunk(
  "OHPaymentUpdateController/OrderHeaderPaymentUpdate",
  async (idata) => {
    const url = store.getState().globalurl.OHPaymentUpdateController;

    // const data = {
    //  idata,
    // };
    const response = await axios.post(url, idata, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    return response.data;
  },
);
export const PartyBydateByamtFilter = createAsyncThunk(
  "PartyBydateByamtFilter/Get",
  async ({ SortType, CompanyID }) => {
    const url = store.getState().globalurl.PartyBydateByamtFilter;

    const data = {
      SortType: SortType,
      CompanyID: CompanyID,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    return response.data;
  },
);

//Audit UserActivityGETController
//   export const auditUserActivityGET = createAsyncThunk(
//   "Audit/UserActivityGET",
//   async ({ CompanyID, UserID,EmployeeID,ActivityType,FromDate,Todate }, { rejectWithValue }) => {
//     try {
//       // const token = sessionStorage.getItem("authToken");

//       // if (!token) {
//       //   return rejectWithValue("Authentication token missing");
//       // }

//  var url = store.getState().globalurl.UserActivityGet;
//       const response = await axios.get(url, {
//         params: {
//           CompanyID,
//           UserID,
//           EmployeeID,
//           ActivityType,
//           FromDate,
//           Todate
//         },
//         headers: {
//           Authorization:
//             "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
//         },
//       });

//       return response.data;
//     } catch (error) {
//       return rejectWithValue(
//         error.response?.data || error.message
//       );
//     }
//   }
// );

export const auditUserActivityGET = createAsyncThunk(
  "Audit/UserActivityGET",
  async ({ data }) => {
    var url = store.getState().globalurl.UserActivityGet;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

//Audit Screen Comapny Get
export const auditScreennameGET = createAsyncThunk(
  "AuditScreen/auditScreennameGET",
  async (_, { rejectWithValue }) => {
    try {
      const url = store.getState().globalurl.auditScreennameGet;

      const response = await axios.post(
        url,
        null, // no payload
        {
          headers: {
            Authorization:
              "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const ExcelFileUpload = createAsyncThunk(
  "ExcelFileUpload/BulkExcelUpload/Post",
  async ({ formData, forcedFileName }) => {
    const baseUrl = store.getState().globalurl.ExcelFileUpload;
    const uploadUrl = `${baseUrl}?filename=${encodeURIComponent(forcedFileName)}`;

    const response = await axios.post(uploadUrl, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });

    return response.data;
  },
);

export const ExcelFileDownload = createAsyncThunk(
  "ExcelFileDownload/BulkExcelDownload/Get",
  async ({ data }) => {
    const baseUrl = store.getState().globalurl.ExcelFileDownload;

    const response = await axios.get(baseUrl, {
      params: data,
      responseType: "blob", // 🔥 IMPORTANT for file download
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });

    return response.data;
  },
);

export const Setup_MenuExcel = createAsyncThunk(
  "Setup_MenuExcel/BulkExcelParams/Post",
  async (excelSetUp) => {
    const baseUrl = store.getState().globalurl.Setup_MenuExcel;
    // const uploadUrl = `${baseUrl}?filename=${encodeURIComponent(forcedFileName)}`;

    const response = await axios.post(baseUrl, excelSetUp, {
      headers: {
        // "Content-Type": "application/json",
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });

    return response.data;
  },
);

export const paySlipGet = createAsyncThunk(
  "paySlipGet/Get",
  async (payslip) => {
    const url = store.getState().globalurl.PayslipGetController;

    const data = {
      EmployeeID: payslip.EmployeeID,
      CompanyID: payslip.CompanyID,
      Finyear: payslip.Finyear,
      Month: payslip.Month,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    return response.data;
  },
);

export const replacementQtyGet = createAsyncThunk(
  "replacementQtyGet/Get",
  async ({ PartyID, CompanyID }) => {
    const url = store.getState().globalurl.PartyReplacementQtyGet;

    const data = {
      PartyID: PartyID,
      CompanyID: CompanyID,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    return response.data;
  },
);


//batchreconciliationGetData
export const batchreconciliationGetData = createAsyncThunk(
  "batchreconciliationGetData/Get",
  async (props) => {
    var url = store.getState().globalurl.apiUrl;
    const data = {
      accessid: props.accessID,
      action: props.get,
      recid: props.recID,
    };
    console.log("🚀 ~ data:", JSON.stringify(data));

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

export const SOPProcessPost = createAsyncThunk(
  "SOPProcessPost/post",
  async ({ idata }) => {
    var url = store.getState().globalurl.SOPProcess;
    const response = await axios.post(url, idata, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
export const SOPConfigPost = createAsyncThunk(
  "SOPConfigPost/post",
  async ({ idata }) => {
    var url = store.getState().globalurl.SOPConfigPost;
    const response = await axios.post(url, idata, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

export const SOPConfigGet = createAsyncThunk(
  "SOPConfigGet/Get",
  async ({ EmployeeID, CompanyID }) => {
    const url = store.getState().globalurl.SOPConfigGet;

    const data = {
      EmployeeID: EmployeeID,
      CompanyID: CompanyID,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    return response.data;
  },
);


export const SpecimenPost = createAsyncThunk(
  "SpecimenPost/post",
  async ({ idata }) => {
    var url = store.getState().globalurl.SpecimenPost;
    const response = await axios.post(url, idata, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

export const SpecimenGet = createAsyncThunk(
  "SpecimenGet/Get",
  async ({ EmployeeID, CompanyID }) => {
    const url = store.getState().globalurl.SpecimenGet;

    const data = {
      EmployeeID: EmployeeID,
      CompanyID: CompanyID,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    return response.data;
  },
);

export const SopEmpMappingController = createAsyncThunk(
  "SopEmpMappingController/post",
  async ({ idata }) => {
    var url = store.getState().globalurl.SopEmpMappingController;
    const response = await axios.post(url, idata, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);

// export const ScoredashBoard = createAsyncThunk(
//   "ScoredashBoard/getdata",
//   async ({ data }, thunkAPI) => {
//     try {
//       var url = store.getState().globalurl.Scoreboard;
//       console.log("get" + JSON.stringify(data));
//       const response = await axios.post(url, data, {
//         headers: {
//           Authorization:
//             "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
//         },
//       });
//       console.log("🚀 ~ response.data:", response.data);
//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

export const PartyOrderPendingGet = createAsyncThunk(
  "PartyOrderPendingGet/Get",
  async ({ PartyID, CompanyID, OrderID }) => {
    const url = store.getState().globalurl.PartypendingorderlistgetController;

    const data = {
      PartyID: PartyID,
      CompanyID: CompanyID,
      OrderID: OrderID
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    return response.data;
  },
);
export const SopTimeLineController = createAsyncThunk(
  "SopTimeLineController/Get",
  async ({ SopID }) => {
    const url = store.getState().globalurl.SopTimeLineController;

    const data = {
      SopID: SopID,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    return response.data;
  },
);

export const GetOverflowAffectedOrders = createAsyncThunk(
  "GetOverflowAffectedOrders/Get",
  async ({ HeaderID }) => {
    const url = store.getState().globalurl.GetOverflowAffectedOrders;

    const data = {
      HeaderID: HeaderID,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    return response.data;
  },
);
export const PartyReset = createAsyncThunk(
  "PartyReset/Post",
  async ({ Data }) => {
    const url = store.getState().globalurl.PartyReset;

    const data = {
      UserID: Data.UserID,
      Password: Data.Password,
      PartyID: Data.PartyID,
      CompanyID: Data.CompanyID
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    return response.data;
  },
);

export const ContractInvoice = createAsyncThunk(
  "ContractInvoice/GET",
  async (data) => {
    const url = store.getState().globalurl.ContractInvoicePDF;

    console.log("POST DATA:", data);

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      }
    });

    return response.data;
  }
);

export const PartyAnalytics = createAsyncThunk(
  "PartyAnalytics/Get",
  async ({ Data }) => {
    const url = store.getState().globalurl.PartyAnalytics;

    const data = {
      companyid: Data.CompanyID,
      fromDate: Data.from,
      toDate: Data.to
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    return response.data;
  },
);

export const TimeTableExcelGet = createAsyncThunk(
  "TimeTableExcelGet/BulkExcel/Get",
  async ({ data }) => {
    const baseUrl = store.getState().globalurl.TimeTableExcelGet;

    const response = await axios.get(baseUrl, {
      params: data,
      responseType: "blob", // 🔥 IMPORTANT for file download
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });

    return response.data;
  },
);

export const TimeTableExcelPost = createAsyncThunk(
  "TimeTableExcelPost/BulkExcel/Post",
  async (excelSetUp) => {
    const baseUrl = store.getState().globalurl.TimeTableExcelPost;
    const response = await axios.post(baseUrl, excelSetUp, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });

    return response.data;
  },
);